import React, { useState } from "react";
import { useEffect } from "react";
import { DragDropContext, Draggable, Droppable } from "react-beautiful-dnd";
import {
  Card,
  Col,
  Container,
  Form,
  OverlayTrigger,
  Tooltip,
  Modal as BModal,
  Form as Bform,
} from "react-bootstrap";
import ReactSelect, { components } from "react-select";
import Header from "../../Header";
import { string, object, number, array } from "yup";
import {
  Button,
  HideDropDown,
  Loading,
  Message,
  Search,
  StatusBar,
} from "../UI";
import ErCanvas from "../UI/ErCanvas";
import * as commonData from "../../Common";
import CustomOption from "../CustomOption";
import { Link, useLocation, useParams } from "react-router-dom";
import Modal from "../UI/modal/Modal";
import { useRef } from "react";
import useHideShowDropDown from "../../helpers/hideshowdropdown";
import { Critical, Deferred, High, Lowest, Medium } from "./jira_priority";
import moment from "moment";
import CustomFilter from "../CustomFilter/CustomFilter";
import NewCustomFilter from "../UI/CustomFilter";
import TodoHandler from "../../utils/TodoHandler";
import AsyncSelect from "react-select/async";
import ReactDatePicker from "react-datepicker";
import { connect, useDispatch, useSelector } from "react-redux";
import action from "../../Actions";
import KainbanIcon from "./KainbanIcon";
import SquareIcon from "./SquareIcon";
import NoRecord from "./NoRecord";
import NoRecordImg from "./NoRecordImg";
import { checkLinkForSideMenu } from "../../Actions/checkLinkForSideMenu";
import Comment from "./jira_priority/Comment";
import Note from "../note_details/Note";
import Error from "../Error";
import MainCanvas from "../UI/TodoCanvas";
import HeaderShowKanban from "./kan_components/HeaderShowKanban";
import FilterIcon from "./kan_components/FilterIcon";
import PlusSvg from "../UI/svg/PlusSvg";
import DraftjsInline from "../er/DraftjsInline";
import CopyLinkItem from "../CopyLinkItem";
import AssignTo from "./kan_components/assignTo/AssignTo";
import Highest from "./jira_priority/Highest";
import { ReactSortable } from "react-sortablejs";
import SwitchToggle from "./SwitchToggle";
import ShowMoreDrop from "./kan_components/ShowMoreDrop";
import BacklogAction from "../BacklogAction";
import BacklogRelate from "../BacklogRelate";
import InfiniteScroll from "react-infinite-scroll-component";
import { StaticRouter } from "react-router-dom/cjs/react-router-dom";
import AutoCompleteRelateER from "../er/AutoCompleteRelateER";
import { BiColumns } from "react-icons/bi";
import BackLogFilter from "../BacklogFilter";
import { CheckPicker } from "rsuite";
import { FaRegCopy } from "react-icons/fa6";
import TimeSvg from "../UI/svg/TimeSvg";
import { getGroupForKanban, setGroupByForkanban } from "../../utils/storeinlocalstorage";
import { deepCleanObject } from "../../utils/utility";
import "rsuite/dist/rsuite.min.css";

async function onRowSequenceUpdate(
  cardData,
  app_token,
  user_uuid,
  attribute_set_key,
  assign,
  api,
  type
) {
  let newsquencedata = [];
  const nedataarray = Object.values(cardData);
  if (type === 4) {
    nedataarray?.map((val) =>
      val?.unpinned?.map((it) => newsquencedata.push(it.customer_tattle_uuid))
    );
  } else {
    Object.entries(nedataarray).map(([key, val]) =>
      val.map((it) => newsquencedata.push(it.customer_tattle_uuid))
    );
  }

  let sequencedata = {
    app_token: app_token,
    user_uuid: user_uuid,
    attribute_set_key: attribute_set_key,
    sequence: newsquencedata,
    assign_to: assign,
  };
  const response = await fetch(`${api}kanban/update-rows-sequence`, {
    method: "POST",
    body: JSON.stringify(sequencedata),
  });
}

function changeKeyPosition(obj, key, newIndex) {
  const keys = Object.keys(obj);

  const currentIndex = keys.indexOf(key);

  if (currentIndex === -1 || newIndex < 0 || newIndex >= keys.length) {
    return obj;
  }

  keys.splice(currentIndex, 1);
  keys.splice(newIndex, 0, key);

  // Create a new object with the updated key order
  const newObj = {};
  keys.forEach((k) => {
    newObj[k] = obj[k];
  });

  return newObj;
}

const onDragEndOther = async (
  result,
  columns,
  setColumns,
  state,
  params,
  userdetails
) => {
  const groupBy = (getGroupForKanban(params.attribute_set_key) || "priority");
  if (!result.destination) return;
  
  const { source, destination, draggableId } = result;
  
  if (result.type === "column") {
    
    const getkanbanselectedobj = localStorage.getItem("selected_filter");
    const app_token = localStorage.getItem("app_token");
    const user_uuid = localStorage.getItem("user_uuid");
    let getid = "";
    const getselectedobjparse = JSON.parse(getkanbanselectedobj);
    getid = getselectedobjparse[state.boarddata.attribute_set_key];
    const newobj = changeKeyPosition(
      state.cardData,
      result.draggableId,
      destination.index
    );
    let sequence = Object.keys(newobj);
    const sequenceorder = {
      filter_id: getid || "",
      app_token: app_token,
      sequence,
      group_by: groupBy,
      user_uuid: user_uuid,
      attribute_set_key: state.boarddata.attribute_set_key,
    };
    setColumns((state) => {
      return {
        ...state,
        cardData: newobj,
      };
    });

    const kanbanOrderResponse = await fetch(
      `${state.api}kanban/kanban-column-ordering-sequence`,
      {
        method: "POST",
        body: JSON.stringify(sequenceorder),
      }
    );

    const rdata = await kanbanOrderResponse.json();

    return;
  }

  let getDropId = state.cardData[source.droppableId]?.find(
    (ite) => ite.customer_tattle_uuid == draggableId
  )?.assign_to;

  if (
    groupBy != "assign_to" &&
    destination &&
    source.droppableId === destination.droppableId
  ) {
    const { cardData } = state;
    let singleCard = cardData[destination.droppableId];
    const [reorderedCard] = singleCard.splice(source.index, 1);
    singleCard.splice(destination.index, 0, reorderedCard);
    
    setColumns((state) => {
      return {
        ...state,
        cardData: {
          ...state.cardData,
          [destination.droppableId]: singleCard,
        },
      };
    });
    let newsquencedata = [];
    const nedataarray = Object.values(cardData);
    Object.entries(nedataarray).map(([key, val]) =>
      val.map((it) => newsquencedata.push(it.customer_tattle_uuid))
    );
    let sequencedata = {
      app_token: userdetails.appToken,
      user_uuid: userdetails.userId,
      attribute_set_key: params.attribute_set_key,
      sequence: newsquencedata,
      assign_to: state.filters.assign_to?.[0],
    };

    const response = await fetch(`${state.api}kanban/update-rows-sequence`, {
      method: "POST",
      body: JSON.stringify(sequencedata),
    });
    return;
  } else if (source.droppableId === destination.droppableId) {
    
    const { cardData } = state;
    const { destination, source, draggableId } = result;
    if (destination && source) {
      let singleCard = cardData[destination.droppableId];
      const [reorderedCard] = singleCard?.splice(source.index, 1);
      singleCard.splice(destination.index, 0, reorderedCard);

      setColumns((state) => {
        return {
          ...state,
          cardData: {
            ...state.cardData,
            [destination.droppableId]: singleCard,
          },
        };
      });

      let sequencedata = {
        app_token: userdetails.appToken,
        user_uuid: userdetails.userId,
        attribute_set_key: params.attribute_set_key,
        sequence: [...singleCard.map((it) => it.customer_tattle_uuid)],
        [groupBy]: destination.droppableId,
      };

      const response = await fetch(`${state.api}kanban/update-rows-sequence`, {
        method: "POST",
        body: JSON.stringify(sequencedata),
      });
      return;
    }
  }

  if (source.droppableId !== destination.droppableId) {
    
    const sourceColumn = columns[source.droppableId];
    const destColumn = columns[destination.droppableId];

    const sourceItems = [...sourceColumn];
    const destItems = [...destColumn];

    if (groupBy == "assign_to") {
      let newvalues = {
        app_token: userdetails.appToken,
        user_uuid: userdetails.userId,
        attribute_set_key: params.attribute_set_key,
        attribute_type: "assign_to",
        attribute_key: "assign_to",
        attribute_value: destination.droppableId,
        customer_tattle_uuid: +draggableId,
      };
      const { cardData } = state;
      let singleCard = cardData[source.droppableId];
      let setiSource = cardData[destination.droppableId];
      const [reorderedCard] = singleCard.splice(source.index, 1);
      setiSource.splice(destination.index, 0, reorderedCard);
      const tododata = setiSource.findIndex(
        (fi) => fi[groupBy] === source.droppableId
      );
      setiSource[tododata] = {
        ...setiSource[tododata],
        [groupBy]: destination.droppableId,
      };
      let destcount = (state.columnsCount[destination.droppableId] || 0) + 1

      let sorccount = (state.columnsCount[source.droppableId] || 1) - 1

      let counts = {
        ...state.columnsCount,
        [destination.droppableId]:destcount,
        [source.droppableId]:sorccount

      }
      setColumns((state) => {
        return {
          ...state,
          cardData: {
            ...state.cardData,
            [destination.droppableId]: setiSource,
          },
          columnsCount:counts
        };
      });
      const response = await fetch(`${state.api}tattle/update-assignto`, {
        method: "POST",
        body: JSON.stringify(newvalues),
      });
      const rdata = await response.json();

      if (rdata.code == 200) {
        onRowSequenceUpdate(
          cardData,
          userdetails.appToken,
          userdetails.userId,
          params.attribute_set_key,
          state.filters.assign_to?.[0],
          state.api,
          state.boarddata.attribute_set_type
        );
      }
    }
    if (groupBy == "priority") {
      let newvalues = {
        app_token: userdetails.appToken,
        user_uuid: userdetails.userId,
        priority: destination.droppableId,
        customer_tattle_uuid: +draggableId,
        attribute_set_key: params.attribute_set_key,
      };
      const formdata = new FormData();
      for (let key in newvalues) {
        formdata.append(key, newvalues[key]);
      }

      const { cardData } = state;
      let singleCard = cardData[source.droppableId];
      let setiSource = cardData[destination.droppableId];
      const [reorderedCard] = singleCard.splice(source.index, 1);
      setiSource.splice(destination.index, 0, reorderedCard);
      const tododata = setiSource.findIndex(
        (fi) => fi[groupBy] === source.droppableId
      );
      setiSource[tododata] = {
        ...setiSource[tododata],
        [groupBy]: destination.droppableId,
      };
      let destcount = (state.columnsCount[destination.droppableId] || 0) + 1

      let sorccount = (state.columnsCount[source.droppableId] || 1) - 1
      

      let counts = {
        ...state.columnsCount,
        [destination.droppableId]:destcount,
        [source.droppableId]:sorccount

      }
      setColumns((state) => {
        return {
          ...state,
          cardData: {
            ...state.cardData,
            [destination.droppableId]: setiSource,
          },
          columnsCount:counts
        };
      });
      const response = await fetch(`${state.api}tattle/update`, {
        method: "POST",
        body: JSON.stringify(newvalues),
      });
      const rdata = await response.json();
      if (rdata.code == 200) {
        onRowSequenceUpdate(
          cardData,
          userdetails.appToken,
          userdetails.userId,
          params.attribute_set_key,
          state.filters.assign_to?.[0],
          state.api
        );
      }
    }
    if (groupBy == "status") {
      
      let newvalues = {
        app_token: commonData.commonData().appToken,
        user_uuid: commonData.commonData().userId,
        status_id: destination.droppableId,
        customer_tattle_uuid: +draggableId,
        attribute_key: "status",
        attribute_set_key: params.attribute_set_key,
      };

      let destcount = (state.columnsCount[destination.droppableId] || 0) + 1

      let sorccount = (state.columnsCount[source.droppableId] || 1) - 1

      let counts = {
        ...state.columnsCount,
        [destination.droppableId]:destcount,
        [source.droppableId]:sorccount

      }

      const { cardData } = state;
      let singleCard = cardData[source.droppableId];
      let setiSource = cardData[destination.droppableId];
      const [reorderedCard] = singleCard.splice(source.index, 1);
      setiSource.splice(destination.index, 0, reorderedCard);
      const tododata = setiSource.findIndex(
        (fi) => fi[groupBy] === source.droppableId
      );
      setiSource[tododata] = {
        ...setiSource[tododata],
        [groupBy]: destination.droppableId,
      };

      setColumns((state) => {
        return {
          ...state,
          cardData: {
            ...state.cardData,
            [destination.droppableId]: setiSource,
          },
          columnsCount:counts
        };
      });
      const response = await fetch(`${state.api}tattle/update-status`, {
        method: "POST",
        body: JSON.stringify(newvalues),
      });
      const rdata = await response.json();
      if (rdata.code == 200) {
        onRowSequenceUpdate(
          cardData,
          state.boarddata.app_token,
          state.boarddata.user_uuid,
          params.attribute_set_key,
          state.filters.assign_to?.[0],
          state.api
        );
      }
    }
  } else {
    const column = columns[source.droppableId];
    const copiesItems = [...column];

    const [removed] = copiesItems.splice(source.index, 1);
    copiesItems.splice(destination.index, 0, removed);

    setColumns((state) => {
      return {
        ...state,
        cardData: {
          ...state.cardData,
          [source.droppableId]: copiesItems,
        },
      };
    });
  }
};

const onDragEndToDo = async (
  result,
  columns,
  setColumns,
  state,
  params,
  userdetails
) => {
  const groupBy = (getGroupForKanban(params.attribute_set_key) || "priority");
  if (!result.destination) return;
  const { source, destination, draggableId } = result;
  if (result.type === "column") {
    const getkanbanselectedobj = localStorage.getItem("selected_filter");
    const app_token = localStorage.getItem("app_token");
    const user_uuid = localStorage.getItem("user_uuid");
    let getid = "";
    const getselectedobjparse = JSON.parse(getkanbanselectedobj);
    getid = getselectedobjparse[state.boarddata.attribute_set_key];
    const newobj = changeKeyPosition(
      state.cardData,
      result.draggableId,
      destination.index
    );
    let sequence = Object.keys(newobj);
    const sequenceorder = {
      filter_id: getid || "",
      app_token: app_token,
      sequence,
      group_by: groupBy,
      user_uuid: user_uuid,
      attribute_set_key: state.boarddata.attribute_set_key,
    };
    setColumns((state) => {
      return {
        ...state,
        cardData: newobj,
      };
    });

    const kanbanOrderResponse = await fetch(
      `${state.api}kanban/kanban-column-ordering-sequence`,
      {
        method: "POST",
        body: JSON.stringify(sequenceorder),
      }
    );

    const rdata = await kanbanOrderResponse.json();

    return;
  }

  let getDropId = state.cardData[source.droppableId]?.["unpinned"]?.find(
    (ite) => ite.customer_tattle_uuid == draggableId
  )?.assign_to;

  if (
    groupBy != "assign_to" &&
    destination &&
    source.droppableId === destination.droppableId
  ) {
    const { cardData } = state;
    let singleCard = cardData[destination.droppableId]?.["unpinned"];
    const [reorderedCard] = singleCard.splice(source.index, 1);
    singleCard.splice(destination.index, 0, reorderedCard);

    let destcount = (state.columnsCount[destination.droppableId] || 0) + 1

    let sorccount = (state.columnsCount[source.droppableId] || 1) - 1

    let counts = {
      ...state.columnsCount,
      [destination.droppableId]:destcount,
      [source.droppableId]:sorccount

    }

    setColumns((state) => {
      return {
        ...state,
        cardData: {
          ...state.cardData,
          [destination.droppableId]: {
            ...state.cardData[destination.droppableId],
            unpinned: singleCard,
          },
          columnsCount:counts
        },
      };
    });
    let newsquencedata = [];
    const nedataarray = Object.values(cardData);
    nedataarray?.map((val) => {
      if (val.hasOwnProperty("unpinned")) {
        val?.["unpinned"].map((it) =>
          newsquencedata.push(it.customer_tattle_uuid)
        );
      }
    });
    let sequencedata = {
      app_token: userdetails.appToken,
      user_uuid: userdetails.userId,
      attribute_set_key: params.attribute_set_key,
      sequence: newsquencedata,
      assign_to: state.filters.assign_to?.[0],
    };

    const response = await fetch(`${state.api}kanban/update-rows-sequence`, {
      method: "POST",
      body: JSON.stringify(sequencedata),
    });
    return;
  } else if (source.droppableId === destination.droppableId) {
    const { cardData } = state;
    const { destination, source, draggableId } = result;
    if (destination && source) {
      let singleCard = cardData[destination.droppableId]?.["unpinned"];
      const [reorderedCard] = singleCard?.splice(source.index, 1);
      singleCard.splice(destination.index, 0, reorderedCard);

      let destcount = (state.columnsCount[destination.droppableId] || 0) + 1

      let sorccount = (state.columnsCount[source.droppableId] || 1) - 1

    let counts = {
      ...state.columnsCount,
      [destination.droppableId]:destcount,
      [source.droppableId]:sorccount

    }

      setColumns((state) => {
        return {
          ...state,
          cardData: {
            ...state.cardData,
            [destination.droppableId]: {
              ...state.cardData[destination.droppableId],
              unpinned: singleCard,
            },
            columnsCount:counts
          },
        };
      });

      let sequencedata = {
        app_token: userdetails.appToken,
        user_uuid: userdetails.userId,
        attribute_set_key: params.attribute_set_key,
        sequence: [...singleCard.map((it) => it.customer_tattle_uuid)],
        [groupBy]: destination.droppableId,
      };

      const response = await fetch(`${state.api}kanban/update-rows-sequence`, {
        method: "POST",
        body: JSON.stringify(sequencedata),
      });
      return;
    }
  }

  if (source.droppableId !== destination.droppableId) {
    const sourceColumn = columns[source.droppableId];
    const destColumn = columns[destination.droppableId];

    const sourceItems = sourceColumn?.["unpinned"] || [];
    const destItems = destColumn?.["unpinned"] || [];

    // setColumns((state) => {
    //   return {
    //     ...state,
    //     cardData: {
    //       ...state.cardData,
    //       [source.droppableId]: {
    //         ...state.cardData[source.droppableId],
    //         unpinned: sourceItems,
    //       },
    //       [destination.droppableId]: {
    //         ...state.cardData[destination.droppableId],
    //         unpinned: destItems,
    //       },
    //     },
    //   };
    // });
    if (groupBy == "assign_to") {
      let newvalues = {
        app_token: userdetails.appToken,
        user_uuid: userdetails.userId,
        attribute_set_key: params.attribute_set_key,
        attribute_type: "assign_to",
        attribute_key: "assign_to",
        attribute_value: destination.droppableId,
        customer_tattle_uuid: +draggableId,
      };
      const { cardData } = state;

      let singleCard = cardData[source.droppableId]?.["unpinned"] || [];
      let setiSource = cardData[destination.droppableId]?.["unpinned"] || [];

      const [reorderedCard] = singleCard.splice(source.index, 1);

      if (groupBy === "assign_to") {
        reorderedCard.assign_to = destination.droppableId;
      }

      setiSource.splice(destination.index, 0, reorderedCard);
      const tododata = setiSource.findIndex(
        (fi) => fi[groupBy] === source.droppableId
      );
      setiSource[tododata] = {
        ...setiSource[tododata],
        [groupBy]: destination.droppableId,
      };
      let destcount = (state.columnsCount[destination.droppableId] || 0) + 1

      let sorccount = (state.columnsCount[source.droppableId] || 1) - 1
  
      let counts = {
        ...state.columnsCount,
        [destination.droppableId]:destcount,
        [source.droppableId]:sorccount
  
      }
      setColumns((state) => {
        return {
          ...state,
          cardData: {
            ...state.cardData,
            [destination.droppableId]: {
              ...state.cardData[destination.droppableId],
              unpinned: setiSource,
            },
          },
          columnsCount:counts
        };
      });
      const response = await fetch(`${state.api}tattle/update-assignto`, {
        method: "POST",
        body: JSON.stringify(newvalues),
      });
      const rdata = await response.json();

      if (rdata.code == 200) {
        onRowSequenceUpdate(
          cardData,
          userdetails.appToken,
          userdetails.userId,
          params.attribute_set_key,
          state.filters.assign_to?.[0],
          state.api
        );
      }
    }
    if (groupBy == "priority") {
      let newvalues = {
        app_token: userdetails.appToken,
        user_uuid: userdetails.userId,
        priority: destination.droppableId,
        customer_tattle_uuid: +draggableId,
        attribute_set_key: params.attribute_set_key,
      };
      const formdata = new FormData();
      for (let key in newvalues) {
        formdata.append(key, newvalues[key]);
      }

      const { cardData } = state;
      let singleCard = cardData[source.droppableId]?.["unpinned"] || [];
      let setiSource = cardData[destination.droppableId]?.["unpinned"] || [];
      const [reorderedCard] = singleCard.splice(source.index, 1);
      setiSource.splice(destination.index, 0, reorderedCard);
      const tododata = setiSource.findIndex(
        (fi) => fi[groupBy] === source.droppableId
      );
      setiSource[tododata] = {
        ...setiSource[tododata],
        [groupBy]: destination.droppableId,
      };
      let destcount = (state.columnsCount[destination.droppableId] || 0) + 1

      let sorccount = (state.columnsCount[source.droppableId] || 1) - 1
  
      let counts = {
        ...state.columnsCount,
        [destination.droppableId]:destcount,
        [source.droppableId]:sorccount
  
      }
      setColumns((state) => {
        return {
          ...state,
          cardData: {
            ...state.cardData,
            [destination.droppableId]: {
              ...state.cardData[destination.droppableId],
              unpinned: setiSource,
            },
          },
          columnsCount:counts
        };
      });
      const response = await fetch(`${state.api}tattle/update`, {
        method: "POST",
        body: JSON.stringify(newvalues),
      });
      const rdata = await response.json();
      if (rdata.code == 200) {

        onRowSequenceUpdate(
          cardData,
          userdetails.appToken,
          userdetails.userId,
          params.attribute_set_key,
          state.filters.assign_to?.[0],
          state.api,
          state.boarddata.attribute_set_type
        );
      }
    }
    if (groupBy == "status") {
      let newvalues = {
        app_token: commonData.commonData().appToken,
        user_uuid: commonData.commonData().userId,
        status_id: destination.droppableId,
        customer_tattle_uuid: +draggableId,
        attribute_key: "status",
        attribute_set_key: params.attribute_set_key,
      };
      const { cardData } = state;
      let singleCard = cardData[source.droppableId]?.["unpinned"] || [];
      let setiSource = cardData[destination.droppableId]?.["unpinned"] || [];
      const [reorderedCard] = singleCard.splice(source.index, 1);
      setiSource.splice(destination.index, 0, reorderedCard);
      const tododata = setiSource.findIndex(
        (fi) => fi[groupBy] === source.droppableId
      );
      setiSource[tododata] = {
        ...setiSource[tododata],
        [groupBy]: destination.droppableId,
      };

      let destcount = (state.columnsCount[destination.droppableId] || 0) + 1

      let sorccount = (state.columnsCount[source.droppableId] || 1) - 1
  
      let counts = {
        ...state.columnsCount,
        [destination.droppableId]:destcount,
        [source.droppableId]:sorccount
  
      }
      
      setColumns((state) => {
        return {
          ...state,
          cardData: {
            ...state.cardData,
            [destination.droppableId]: {
              ...state.cardData[destination.droppableId],
              unpinned: setiSource,
            },
          },
          columnsCount:counts
        };
      });
      const response = await fetch(`${state.api}tattle/update-status`, {
        method: "POST",
        body: JSON.stringify(newvalues),
      });
      const rdata = await response.json();
      if (rdata.code == 200) {
        onRowSequenceUpdate(
          cardData,
          state.boarddata.app_token,
          state.boarddata.user_uuid,
          params.attribute_set_key,
          state.filters.assign_to?.[0],
          state.api
        );
      }
    }
  } else {
    const column = columns[source.droppableId];
    const copiesItems = column?.["unpinned"] || [];

    const [removed] = copiesItems.splice(source.index, 1);
    copiesItems.splice(destination.index, 0, removed);

    setColumns((state) => {
      return {
        ...state,
        cardData: {
          ...state.cardData,
          [source.droppableId]: {
            ...state.cardData[source.droppableId],
            unpinned: copiesItems,
          },
        },
      };
    });
  }
};

const getNoteLink = (item, key, type) => {
  if (type === 4 || type === 10) {
    return;
  }
  return (
    <>
      Note{" "}
      <Link
        to={`/tattle/${key}/${item.customer_tattle_uuid}#note${
          item?.custom_note_uuid || item?._id
        }`}
        className="note-link"
        target="_blank"
      >
        {item?.custom_note_uuid || item?._id}
      </Link>{" "}
      &nbsp;&nbsp; | &nbsp;&nbsp;
    </>
  );
};

const getCallBoardDetailsApi = async (state, setState, params) => {
  const localdata = localStorage.getItem("selected_filter");

  let requests = {
    app_token: commonData.getCommonData().app_token,
    attribute_set_key: params.attribute_set_key,
    user_uuid: commonData.getCommonData().user_uuid,

  };
  const response = await fetch(`${state.api}/board-details`, {
    method: "POST",
    body: JSON.stringify(requests),
  });

  const rdata = await response.json();

  if (rdata.code == 200) {
    const [board] = rdata.data;
    const { filter } = board;
    setState((state) => {
      return {
        ...state,
        filterView: filter,
        boarddata: board,
      };
    });
    return rdata;
  }
};

const getPeoplesCall = async (evt, apiUrl, state, setState) => {
  if (evt && state.activeUsers.length > 0) {
    return state.activeUsers.filter((item) =>
      item.label.toLowerCase().includes(evt.toLowerCase())
    );
  }

  try {
    if (!state.activeUsers.length > 0) {
      if (!state.getPeopleApiCall) {
        const resp = await fetch(apiUrl);
        const rdata = await resp.json();

        const newdata = Object.entries(rdata).map(([key, val]) => {
          return {
            label: val.name,
            value: val.user_uuid,
            profile_image: val.profile_image,
          };
        });
        setState((state) => {
          return {
            ...state,
            activeUsers: newdata,
            getPeopleApiCall: true,
          };
        });

        return newdata;
      }
    }
    return state.activeUsers;
  } catch (error) {
    console.log(error.message);
  }
};

const Kanban = (props) => {
  const dispatch = useDispatch();
  const params = useParams();
  const newloc = useLocation();
  const kanbanref = useRef(null);
  const [open, setOpen] = useState(false);
  const [assigntorelease, setAssignToRelease] = useState(false);
  const [isMounted, setIsMounted] = useState(false);
  const [releaseassignvalue, setReleaseAssgnValue] = useState("");
  const [triggerApiCall, setTriggerApiCall] = useState(false);
  const [state, setState] = useState({
    api: commonData.getCommonData().apiUrl,
    showAddCanvas: false,
    isResetFilter: false,
    enableCustomView: false,
    hasMore: true,
    assignToReleaseData: [],
    editShowCanvas: false,
    isBulkUpload: false,
    showattrdrop: false,
    showTodoNote: false,
    filters: {},
    currentPage: {},
    isCallingApi: false,
    filterView: [],
    notes: [],
    explicitGroupChange: "",
    isLoading: false,
    addNoteData: {},
    users: {},
    newOptionColumns: [],
    customer_type: "internal",
    isReleaseFromBack: false,
    completed: "",
    columns: [],
    showColumnsArray: [],
    clearautocomplete: false,
    related_tattle_id: "",
    errorRelation: {},
    columnsCount: {},
    isFetching: true,
    linkCopied: false,
    editId: "",
    cardData: {},
    showFilterSection: false,
    groups: [
      { label: "Priority", value: "priority" },
      { label: "Status", value: "status" },
      { label: "Assign To", value: "assign_to" },
    ],
    attribute_set_key: "",

    isShowKanban: false,
    isFilterCreate: false,
    highlighted: "",
    newfilters: {},
    editFilterId: "",
    modalFilterNameError: "",
    isDisabledChecked: false,
    editFilterValues: "",
    isFilterRemove: false,
    draggingDone: false,
    showmoredrop: false,
    copied: false,
    assignUsers: [],
    isShowCompleteDropdown: false,
    createBoard: {
      board: false,
      title: "",
      message: "",
      position: "bottom-end",
      bg: "",
      code: "",
    },
    showGroupDropDown: false,
    showDropDownGroup: false,
    loading: false,
    formdata: {},
    isSetNotAllowed: false,
    getPeopleApiCall: false,
    globalSearch: "",
    showAllattribute: false,
    isSubmitting: false,
    activeUsers: [],
    boarddata: {},
    kanbanName: "",
  });
  const customFilterName = useRef(null);
  const groupByRefs = useRef(null);
  const containerRef = useRef(null);
  const defaultUserLogin = useRef({});
  const scrollRef = useRef(null);
  let clearform = useRef(null);
  let completeDropdown = useRef(null);
  let dropdowmScroll = useRef(null);
  let clearFormSelect = useRef(null);
  let userdetails = commonData.commonData();
  const focusRef = useRef(null);
  const refgroupcategory = useRef(null);
  const refgroupcategorytech = useRef(null);
  const refgroupcategoryMain = useRef(null);
  const timeframe = useRef(null);

  const togglemenu = useSelector((state) => state.boardAttribute.toggleMenu);

  useHideShowDropDown(groupByRefs, () => {
    showGroupByDropDown();
  });
  useHideShowDropDown(kanbanref, () => {
    showIsKanban();
  });

  useHideShowDropDown(completeDropdown, () => {
    closeCompleDropdown();
  });
  const showGroupDropDown = () => {
    setState((state) => {
      return {
        ...state,
        showDropDownGroup: true,
      };
    });
  };

  const closeCompleDropdown = () => {
    setState((state) => {
      return {
        ...state,
        isShowCompleteDropdown: false,
      };
    });
  };
  const inputChangeCheckboxHandler = (newvalue) => {
    const kanbanfilter = localStorage.getItem("filter");
    const kanbanselectedfilter = localStorage.getItem("selected_filter");
    const groupBy = (getGroupForKanban(params.attribute_set_key) || "priority");

    let filter = {};

    if (kanbanfilter && commonData.IsJsonString(kanbanfilter)) {
      let parsekanbanfilter = JSON.parse(kanbanfilter);
      parsekanbanfilter = {
        ...parsekanbanfilter,
      };

      if (
        Object.keys(parsekanbanfilter).length && (parsekanbanfilter[params.attribute_set_key]?.group_by || groupBy) !== "assign_to"
      ) {
        if (parsekanbanfilter[params.attribute_set_key] && typeof parsekanbanfilter[params.attribute_set_key] == "object" && "columns" in parsekanbanfilter[params.attribute_set_key]) delete
        parsekanbanfilter[params.attribute_set_key].columns
      
        parsekanbanfilter = {
          [params.attribute_set_key]: JSON.stringify({
            ...(typeof parsekanbanfilter[params.attribute_set_key] === "object" && JSON.parse(parsekanbanfilter[params.attribute_set_key])),
            columns: newvalue,
          }),
        };
      } else {
        parsekanbanfilter = JSON.stringify({
          ...parsekanbanfilter,
          [params.attribute_set_key]: {
            columns: newvalue,
          },
        });
      }

      let newfilter = {};

      if (groupBy === "assign_to") {
        newfilter.filters = {
          // ...state.filters,
          assign_to: [...newvalue],
          columns: newvalue,
        }
      } else {
        newfilter.filters = {
          // ...state.filters,

          columns: newvalue,
        }
      }

      setState((state) => {
        return {
          ...state,
     
          ...newfilter

        };
      });

      filter = parsekanbanfilter[params.attribute_set_key];
      


      localStorage.setItem("filter", JSON.stringify(parsekanbanfilter));
    }

    
 
     const { columns, ...restvalue } = commonData.IsJsonString(filter) && (JSON.parse(filter) || {});
        callTheApiDefaut({restvalue,...state.filters} || null, null, newvalue);
  };
  // show canvas for adding more item
  const addNewItemHandler = (userid) => {
    setState((state) => {
      return {
        ...state,
        showAddCanvas: true,
        findUUID: userid,
        user_uuid: userid,
        editId: "",
        formdata: {},
      };
    });
  };

  const moveToDynamicUrl = (evt) => {
    evt.preventDefault();

    // return;
    const urlEncodedData = encodeURIComponent(JSON.stringify(state.filters));
    if (checkurlParam()) {
      props.history.push(
        `/tattle/${params.attribute_set_key}/list?q=${urlEncodedData}`
      );
    } else {
      props.history.push(`/tattle/${params.attribute_set_key}/list`);
    }
  };

  const customerTypeHandler = (evt) => {
    const { name, value } = evt.target;
    setState((state) => {
      return {
        ...state,
        customer_type: value,
      };
    });
  };

  // get the note typ in note like internal or customer
  const getNoteTypeValue = (item) => {
    let notetype;
    if (params.attribute_set_key === "support-ticket") {
      if (item.note_type === "customer")
        notetype = <span className="customer">To Customer</span>;
      if (item.note_type === "internal")
        notetype = <span>{item.note_type}</span>;
      if (item.note_type === "external")
        notetype = <span className="customer">To Customer</span>;
    }
    return notetype;
  };
  const checkurlParam = () => {
    const query = new URLSearchParams(window.location.search).get("q");
    return query;
  };

  // this function return the two icon list and kanban icon in header as per the condition (list / kanban)
  const getKanbanViewUi = () => {
    let geturlpath =
      newloc.pathname.split("/")[newloc.pathname.split("/").length - 1];
    let url = "";
    if (geturlpath == "kanban" && checkurlParam()) {
      url = `/tattle/${params.attribute_set_key}/list?q=${encodeURIComponent(
        checkurlParam()
      )}`;
    } else {
      const urlSearch = new URLSearchParams(window.location.search).get("q");
      const encodeddata = encodeURIComponent(urlSearch);
      url = `/tattle/${params.attribute_set_key}/kanban?q=${encodeddata}`;
    }
    if (geturlpath && geturlpath == "list") {
      return (
        <div className="group_view">
          <OverlayTrigger
            key={"kanban"}
            placement={"top"}
            overlay={
              <Tooltip id={`tooltip-kanban`}>
                <strong>Kanban View</strong>
              </Tooltip>
            }
          >
            <div className={`child_group_view_kanban`}>
              <Link to={`kanban`}>
                <img src={`${window.location.origin}/grid.png`} width={24} />
              </Link>
            </div>
          </OverlayTrigger>
          <OverlayTrigger
            key={"list"}
            placement={"top"}
            overlay={
              <Tooltip id={`tooltip-list`}>
                <strong>List View</strong>
              </Tooltip>
            }
          >
            <div className={`child_group_view_square active`}>
              <Link to={`list`}>
                <img src={`${window.location.origin}/list.png`} width={24} />
              </Link>
            </div>
          </OverlayTrigger>
        </div>
      );
    } else {
      let url = "";
      if (geturlpath == "kanban" && checkurlParam()) {
        url = `/tattle/${params.attribute_set_key}/list?q=${encodeURIComponent(
          checkurlParam()
        )}`;
      } else {
        const urlSearch = new URLSearchParams(window.location.search).get("q");
        const encodeddata = encodeURIComponent(urlSearch);
        url = `/tattle/${params.attribute_set_key}/list`;
      }
      if (checkViewType()) {
        return (
          <div className="group_view">
            <OverlayTrigger
              key={"list"}
              placement={"top"}
              overlay={
                <Tooltip id={`tooltip-list`}>
                  <strong>List View</strong>
                </Tooltip>
              }
            >
              <div className="child_group_view_square inactive">
                <Link to="#" onClick={moveToDynamicUrl}>
                  {/* <SquareIcon /> */}
                  <img src={`${window.location.origin}/list.png`} width={24} />
                </Link>
              </div>
            </OverlayTrigger>
            <OverlayTrigger
              key={"kanban"}
              placement={"top"}
              overlay={
                <Tooltip id={`tooltip-kanban`}>
                  <strong>Kanban View</strong>
                </Tooltip>
              }
            >
              <div className="child_group_view_kanban active">
                <Link
                  to={`${window.location.pathname}${window.location.search}`}
                >
                  {/* <KainbanIcon className="active" /> */}
                  <img src={`${window.location.origin}/grid.png`} width={24} />
                </Link>
              </div>
            </OverlayTrigger>
          </div>
        );
      }
      return (
        <div className="group_view">
          <OverlayTrigger
            key={"list"}
            placement={"top"}
            overlay={
              <Tooltip id={`tooltip-list`}>
                <strong>List View</strong>
              </Tooltip>
            }
          >
            <div className="child_group_view_square inactive">
              <Link to="#" onClick={moveToDynamicUrl}>
                {/* <SquareIcon /> */}
                <img src={`${window.location.origin}/list.png`} width={24} />
              </Link>
            </div>
          </OverlayTrigger>
          <OverlayTrigger
            key={"kanban"}
            placement={"top"}
            overlay={
              <Tooltip id={`tooltip-kanban`}>
                <strong>Kanban View</strong>
              </Tooltip>
            }
          >
            <div className="child_group_view_kanban active">
              <Link
                to={
                  checkurlParam()
                    ? `/tattle/${
                        params.attribute_set_key
                      }/kanban?q=${encodeURIComponent(checkurlParam())}`
                    : `/tattle/${params?.attribute_set_key}/kanban`
                }
              >
                {/* <KainbanIcon className="active" /> */}
                <img src={`${window.location.origin}/grid.png`} width={24} />
              </Link>
            </div>
          </OverlayTrigger>
        </div>
      );
    }
  };

  // this function return the note list in the modal
  const getNoteListHandler = () => {
    if (state.isLoading && state.notes.length === 0) {
      return (
        <div className="details-fullpageAddTodo-loading">
          <Loading />
        </div>
      );
    }
    if (state.notes.length === 0) {
      return (
        <div className="notes_parents">
          <div className="No_notes_parents">
            <div class="card-body no-content">
              <div class="svg reset">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  fill="none"
                  viewBox="0 0 24 24"
                  stroke-width="1.5"
                  stroke="currentColor"
                  class="w-6 h-6"
                  width="50px"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    d="M20.25 8.511c.884.284 1.5 1.128 1.5 2.097v4.286c0 1.136-.847 2.1-1.98 2.193-.34.027-.68.052-1.02.072v3.091l-3-3c-1.354 0-2.694-.055-4.02-.163a2.115 2.115 0 01-.825-.242m9.345-8.334a2.126 2.126 0 00-.476-.095 48.64 48.64 0 00-8.048 0c-1.131.094-1.976 1.057-1.976 2.192v4.286c0 .837.46 1.58 1.155 1.951m9.345-8.334V6.637c0-1.621-1.152-3.026-2.76-3.235A48.455 48.455 0 0011.25 3c-2.115 0-4.198.137-6.24.402-1.608.209-2.76 1.614-2.76 3.235v6.226c0 1.621 1.152 3.026 2.76 3.235.577.075 1.157.14 1.74.194V21l4.155-4.155"
                  />
                </svg>
              </div>
              <div class="title mt-3">No Notes found</div>
              <div class="sub-title">Your Notes will show up here.</div>
            </div>
          </div>
        </div>
      );
    }
    return (
      <div className="details-fullpageAddTodo">
        <div className="editNoteContent">
          <div className="addNote-Self">
            <div class="row justify-content-start" id="note335057">
              {state.notes.map((item, index) => {
                let image;
                if (state.users) {
                  image = state.users[item.user_uuid]?.profile_image;
                } else {
                  image = item?.user_details?.profile_image;
                }
                return (
                  <div class="col-lg-12 mt-3">
                    <div
                      class={`self-singlebox ${
                        item?.note_type === "customer" ||
                        item?.note_type === "external"
                          ? "customer"
                          : ""
                      }`}
                    >
                      <div className="d-flex justify-content-between align-items-center">
                        <div class="topPart d-flex justify-content-start align-items-center">
                          <div class="left-side firstLetter">
                            <img src={`${image}`} />
                          </div>
                          <div class="right-side">
                            <div class="name">
                              {item.user_details?.profile_url &&
                              item.user_details?.name ? (
                                <a
                                  target={"_blank"}
                                  href={item?.user_details?.profile_url}
                                  className="checkUserNameNote"
                                >
                                  {" "}
                                  {item?.user_details?.name}
                                </a>
                              ) : (
                                <a
                                  target={"_blank"}
                                  href={
                                    state.users[item?.user_uuid]?.profile_url
                                      ? state.users[item?.user_uuid]
                                          ?.profile_url
                                      : ""
                                  }
                                  className="checkUserNameNote"
                                >
                                  {state.users[item?.user_uuid]?.name}
                                </a>
                              )}

                              {getNoteTypeValue(item)}
                            </div>

                            <div class="noteDesc self">
                              {getNoteLink(
                                item,
                                params.attribute_set_key,
                                state.boarddata.attribute_set_type
                              )}
                              {moment(item?.created_at).format(
                                process.env.REACT_APP_DATE_TIME_FORMAT
                              )}{" "}
                              &nbsp;&nbsp; | &nbsp;&nbsp;
                              <CopyLinkItem
                                item={item}
                                attribute_set_key={params.attribute_set_key}
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                      <div className="reasonsec">
                        {item?.hasOwnProperty("reason") &&
                          Object.keys(item.reason).length > 0 &&
                          Object.keys(item.reason).map((nitem) => {
                            return (
                              <li>
                                <strong>{nitem} </strong>: {item.reason[nitem]}
                              </li>
                            );
                          })}
                      </div>
                      <div
                        class="note-text"
                        dangerouslySetInnerHTML={{
                          __html: convertNoteContent(item?.note_content),
                        }}
                      ></div>
                    </div>
                  </div>
                );
              })}
              <div ref={scrollRef}></div>
            </div>
          </div>
        </div>
      </div>
    );
  };
  const showMoreDropDownhandler = (e) => {
    e.stopPropagation();
    setState((state) => {
      return {
        ...state,
        showmoredrop: true,
      };
    });
  };

  // this function return the UI for adding a note for kanaban where we check the condition to show the internal and customer for support ticket
  const getNoteTodoView = () => {
    let returnNoteTodo;

    returnNoteTodo = (
      <div className="manageTodoNote">
        {getNoteListHandler()}

        <div
          className={`todoNote ${
            state.boarddata.attribute_set_type === 2 ? "support" : ""
          }`}
        >
          {state.boarddata.attribute_set_type === 2 && (
            <div className="internal_replaytocustomer">
              <div class="d-flex">
                <div class="form-check me-4">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="internal"
                    checked={state.customer_type == "internal"}
                    value="internal"
                    onClick={customerTypeHandler}
                  />
                  <label class="form-check-label" for="level_display1">
                    Internal Only
                  </label>
                </div>
                <div class="form-check">
                  <input
                    class="form-check-input"
                    type="radio"
                    name="external"
                    checked={state.customer_type == "external"}
                    value="external"
                    onClick={customerTypeHandler}
                  />
                  <label class="form-check-label" for="level_display2">
                    Reply to Customer
                  </label>
                </div>
              </div>
            </div>
          )}
          <Error>
            <Note
              getRawData={getRawData}
              users={state.users || {}}
              addnote={true}
              toolbar={true}
              isAdding={""}
              buttonDisabled={state.isLoading}
            />
          </Error>
        </div>
      </div>
    );

    return returnNoteTodo;
  };

  const callingForNewRecord = async (columnId) => {
    const groupBy = getGroupForKanban(params.attribute_set_key) || "priority"
    const {
      filter_id,
      filter_view,
      assign_to,
      columns,
      advance_filter,
      ...rest
    } = state.filters;

    let newfilters = {
      ...rest,
    };

    for (let key in newfilters) {
      if (
        typeof newfilters[key] === "object" &&
        !Array.isArray(newfilters[key])
      ) {
        delete newfilters[key];
      }
    }

    if (
      groupBy === "assign_to" &&
      params.attribute_set_type === 4
    ) {
      newfilters = {
        ...newfilters,
        assign_to: [columnId],
      };
    }

    if (state.filters.hasOwnProperty(columnId)) {
      newfilters = {
        ...newfilters,
        priority: [...state.filters[columnId]?.priority],
      };
    }

    if(newfilters && "group_by" in newfilters) delete newfilters.group_by

    const response = await fetch(`${state.api}/kanban/filter-kanban-columns`, {
      method: "POST",
      body: JSON.stringify({
        app_token: commonData.getCommonData().app_token,
        attribute_set_key: params.attribute_set_key,
        column_id: columnId,
        group_by: groupBy,
        advance_filter,
        columns,
        current_page:
          state.currentPage.hasOwnProperty(columnId) &&
          state.currentPage?.[columnId]
            ? state.currentPage[columnId]
            : 2,
        filters: {
          ...newfilters,
        },
      }),
    });

    const rdata = await response.json();

    if (rdata.code === 200) {
      if (state.boarddata.attribute_set_type !== 4) {
        const newdatacards = [
          ...(state.cardData[columnId] || []),
          ...rdata.data,
        ];

        setState((state) => {
          return {
            ...state,
            cardData: {
              ...state.cardData,
              [columnId]: newdatacards,
            },
            hasMore: rdata.data.length === 20,
            currentPage: {
              ...state.currentPage,
              [columnId]: rdata.current_page + 1,
            },
          };
        });
      } else {
        const newdatacards = [
          ...(state.cardData[columnId]?.unpinned || []),
          ...rdata.data,
        ];
        setState((state) => {
          return {
            ...state,
            cardData: {
              ...state.cardData,
              [columnId]: {
                pinned: state.cardData[columnId]?.pinned || [],
                unpinned: newdatacards,
              },
            },
            hasMore: rdata.data.length === 20,
            currentPage: {
              ...state.currentPage,
              [columnId]: rdata.current_page + 1,
            },
          };
        });
      }
    }
  };

  useEffect(() => {
    document.title = `${state.boarddata.attribute_set_name || ""} ${
      state.boarddata.attribute_set_name ? "| Kanban" : ""
    }`;
    action.checkLinkForSideMenu(params.attribute_set_key);
    const getUsers = state.activeUsers.find(
      (item) => item.value == state.findUUID
    );

    if (getUsers) {
      setState((state) => {
        return {
          ...state,
          username: getUsers?.label,
          user_uuid: getUsers?.value,
        };
      });
    }
  }, [
    state.findUUID,
    state.activeUsers,
    state.cardData,
    state.editId,
    state.editShowCanvas,
  ]);
  //default check and set the default value

  const defaultCheck = (field, value, formik) => {
    defaultUserLogin.current = {
      ...defaultUserLogin.current,
      [field]: value,
    };
  };

  // close add canvas form
  const closeAddCanvas = () => {
    setState((state) => {
      return {
        ...state,
        showAddCanvas: false,
      };
    });
  };
  const assigntoReleasechange = (evt) => {
    setReleaseAssgnValue(evt.value);
  };

  // canvas for edit the item
  const onDragEditHandler = (id, customer_tattle_uuid, pinned) => {
    let getformdata = [
      ...(state.cardData?.[id]?.["pinned"] || []),
      ...(state.cardData?.[id]?.["unpinned"] || []),
    ]?.find((item) => item.customer_tattle_uuid == customer_tattle_uuid);

    setState((state) => {
      return {
        ...state,
        editShowCanvas: true,
        formdata: getformdata,
        findUUID: id,
        user_uuid: id,
        editId: customer_tattle_uuid,
      };
    });
  };

  const convertDateFormat = (date) => {
    let convertdate = moment(date).format("YYYY-MM-DD");
    return convertdate;
  };
  const reactDatePickerHandler = (evt, formik, field) => {
    let date = convertDateFormat(evt);
    formik.setFieldValue(field, date);
  };
  const closeEditCanvas = () => {
    setState((state) => {
      return {
        ...state,
        editShowCanvas: false,
      };
    });
  };

  const closeCustomFilter = () => {
    setState((state) => {
      return {
        ...state,
        enableCustomView: false,
        editFilterValues: "",
      };
    });
  };

  const getAllUserList = async () => {
    const response = await fetch(
      `${state.api}/get-all-users?app_token=${
        commonData.getCommonData()?.app_token
      }`
    );
    const rdata = await response.json();
    if (response) {
      setState((state) => {
        return {
          ...state,
          users: rdata,
        };
      });
    }
  };

  const checkViewType = () => {
    return new URLSearchParams(window.location.search).get("type") ?? undefined;
  };
  useEffect(() => {
    let getfilters = localStorage.getItem("filter");
    if (getfilters) {
      const parseFilter = JSON.parse(getfilters);

      const parsringdata = parseFilter[params.attribute_set_key];
      if (isValidJson(parsringdata)) {
        setState((state) => {
          return {
            ...state,
            filters: JSON.parse(parsringdata) || {},
          };
        });
      } else {
        setState((state) => {
          return {
            ...state,
            filters: parsringdata || {},
          };
        });
      }
    }
    const timer = setTimeout(() => {
      setIsMounted(true);
    }, 1000); // Small delay to avoid flicker

    document.addEventListener("mousedown", hideGroupCategoryDropdown);
    return () => {
      document.removeEventListener("mousedown", hideGroupCategoryDropdown);
      // window.removeEventListener("resize", resizeHandler);
      clearTimeout(timer); // Cleanup on unmount
    };
  }, []);

  const hideGroupCategoryDropdown = (evt) => {
    
    const searchInput = document.querySelector(".rs-search-box-input");
    if (
      evt.target !== searchInput &&
      refgroupcategoryMain.current &&
      !refgroupcategoryMain.current.contains(evt.target) &&
      refgroupcategory.current &&
      !refgroupcategory.current.contains(evt.target)
    ) {
      setState((state) => {
        return {
          ...state,
          showDropDownGroup: false,
        };
      });
    }
  };

  useEffect(() => {
    (async () => {
      dispatch(checkLinkForSideMenu(params.attribute_set_key));
      let backlogUrl = new URLSearchParams(window.location.search).get("aq");
      let newbacklogdata = "";
      if (backlogUrl) {
        backlogUrl = backlogUrl.replace(/\\"/g, '"');
        backlogUrl = backlogUrl.trim().replace(/^"|"$/g, "");
        newbacklogdata = commonData.IsJsonString(backlogUrl)
          ? JSON.parse(backlogUrl)
          : "";

        setState((state) => {
          return {
            ...state,
            advance_filter: newbacklogdata,
            filters: {
              ...state.filters,
            },
          };
        });
      }

      let newurl = new URLSearchParams(window.location.search).get("q");
      let newconvertdata = "";
      let newcoluns = [];
      if (checkViewType() === "backlog") {
        setState((state) => {
          return {
            ...state,
            filters: {
              ...state.filters,
            },
          };
        });
      }
      if (newurl) {
        newurl = newurl.replace(/\\"/g, '"');
        newurl = newurl.trim().replace(/^"|"$/g, "");
        newconvertdata = commonData.IsJsonString(newurl)
          ? JSON.parse(newurl)
          : "";

        if (newconvertdata.hasOwnProperty("columns")) {
          const { columns, ...rest } = newconvertdata;
          newconvertdata = rest;
          newcoluns = columns;
          
          setState((state) => {
            return {
              ...state,
              filters: {
                ...state.filters,
                ...rest,
                columns,
              },
            };
          });
        } else {
        setState((state) => {
          return {
            ...state,
            filters: {
              ...state.filters,
              ...newconvertdata,
            },
          };
        });
      }
      }

      setState((state) => {
        return {
          ...state,
          attribute_set_key: params.attribute_set_key,
        };
      });
      // call Board details api

      const redata = await getCallBoardDetailsApi(state, setState, params);

      let requestData = {
        app_token: commonData.getCommonData().app_token,
        attribute_set_key: params.attribute_set_key,
        attribute_status: true,
      };

      const fetchAttributesCall = async () => {
        setState((state) => {
          return {
            ...state,
            loading: true,
          };
        });
        const resp = await fetch(`${state.api}/tattle/attributes`, {
          method: "POST",
          body: JSON.stringify(requestData),
        });

        const rdata = await resp.json();

        if (rdata.code === 200) {
          const { data } = rdata;
          setState((state) => {
            return {
              ...state,
              loading: false,
              columns: [
                ...rdata?.data,
                {
                  attribute_type: "subdate",
                  show_in_kanban: true,
                  field: "subdate",
                },
              ],
              // users: data.users,
            };
          });
          getAllUserList();
        }
      };

      fetchAttributesCall();

      if (redata.code == 200) {
        const [boarddata] = [...redata.data] || [];
        const { filter } = boarddata;
        const { selectedFilterId } = params;

        if (selectedFilterId) {
          const { system_filter } = filter;
          let filterassingme = system_filter?.find(
            (ite) => ite?.is_default === 1
          );
          let filter_id = filterassingme?.filter_id;
          if (
            filterassingme &&
            commonData.IsJsonString(filterassingme?.filter_value) &&
            !newconvertdata
          ) {
            filterassingme = JSON.parse(filterassingme?.filter_value);

            localStorage.setItem(
              "selected_filter",
              JSON.stringify({ [params.attribute_set_key]: filter_id })
            );

            callTheApiDefaut(filterassingme, boarddata);
            return;
          }
        }
        if (newbacklogdata) {
          localStorage.setItem(
            "advance_filter",
            JSON.stringify({ [params.attribute_set_key]: newbacklogdata })
          );
          callTheApiDefaut(
            { advance_filter: { ...newbacklogdata } },
            boarddata
          );
          return;
        }
        if (newconvertdata) {
          localStorage.setItem(
            "selected_filter",
            JSON.stringify({ [params.attribute_set_key]: "" })
          );
          let newconvertdatastring = JSON.stringify(newconvertdata)
          localStorage.setItem(
            "filter",
            JSON.stringify({ [params.attribute_set_key]: newconvertdatastring })
          );
          callTheApiDefaut(newconvertdata, boarddata, newcoluns ?? []);
          return;
        }
        if (filter) {
           const localdata = getDataFromStorage("filter");
                   
                   if(localdata) {
                     const filterdata = JSON.parse(localdata) || {};
                     
                     const { columns, group_by, ...rest } = filterdata
                     const group = getGroupForKanban(params.attribute_set_key)
                     filterdata.group_by = group || "priority";
                     setState(state => {
                       return {
                         ...state,
                         filters: { ...rest }
                       }
                     })
                     
                     callTheApiDefaut(rest, boarddata, columns || []);
                     return;
                   }

          if (
            filter.hasOwnProperty("system_filter") &&
            (!localdata || Object.keys(localdata).length === 0)
          ) {
            const checkIsDefault = filter.system_filter.find(
              (it) => it.is_default
            );
            
            if (checkIsDefault) {
              let otherdata = localStorage.getItem("filter");
              if (otherdata && commonData.IsJsonString(otherdata)) {
                otherdata = JSON.parse(otherdata);
              }
              const values = JSON.parse(checkIsDefault.filter_value);
              localStorage.setItem(
                "selected_filter",
                JSON.stringify({
                  [params.attribute_set_key]: checkIsDefault.filter_id,
                })
              );
              const {group_by,...rest} = values;

              let newvalues = JSON.stringify(rest);
              localStorage.setItem(
                "filter",
                JSON.stringify({
                  ...otherdata,
                  [params.attribute_set_key]: newvalues,
                })
              );
                            setGroupByForkanban(group_by, params.attribute_set_key)
                            callTheApiDefaut({ ...rest, group_by }, boarddata);
              return;
            }
          }
        }
        const getdatafilters = getDataFromLocalAndDefault(filter);
        callTheApiDefaut(getdatafilters, boarddata);
      }
    })();
  }, []);

  const getDataFromStorage = (key, filter) => {
    // get value from local storage using key which we receive in the function
    let values = localStorage.getItem(key);
    if (key === "selected_filter" && values) {
      let parseData = commonData.IsJsonString(values) ? JSON.parse(values) : "";
      if (parseData) {
        let getdataselect = parseData[params.attribute_set_key];
        const { user_filter } = filter;
        if (user_filter.length) {
          let getvalue = user_filter.find(
            (it) => it.filter_id == getdataselect
          );
          if (getvalue) {
            let parsedata = JSON.parse(getvalue.filter_value);
            setState((state) => {
              return {
                ...state,
                filters: {
                  ...state.filters,
                  ...JSON.parse(getvalue.filter_value),
                },
              };
            });

            return parsedata;
          }
        }
      }

      return;
    } else if (key == "filter") {
      if (values) {
        const parseData = commonData.IsJsonString(values)
          ? JSON.parse(values)
          : "";
        const data = parseData[params.attribute_set_key];
        if (data) {
          return data;
        }
      }
    } else if (key == "default") {
      let getvalue = JSON.parse(filter.filter_value);

      let newdefault = {};
      let newdata = localStorage.getItem("selected_filter");

      if (newdata) {
        let newparsedata = commonData.IsJsonString(newdata)
          ? JSON.parse(newdata)
          : "";
        if (newparsedata) {
          newdefault = {
            ...newparsedata,
            [params.attribute_set_key]: filter.filter_id,
          };
          localStorage.setItem(
            "selected_filter",
            JSON.stringify(newdefault)
          );
        }
      } else {
        newdefault = {
          [params.attribute_set_key]: filter.filter_id,
        };
        localStorage.setItem(
          "selected_filter",
          JSON.stringify(newdefault)
        );
      }

      return getvalue;
    }
  };

  const convertNoteContent = (data) => {
    const linkRegex = /<a[^>]*>.*?<\/a>|((http:\/\/|https:\/\/)[^\s]+)/gi;

    return data.replace(linkRegex, (match, group1) => {
      if (group1) {
        return `<a href="${group1
          .replace(/<p>/g, "")
          .replace(/<\/p>/g, "")}" target="_blank">${group1}</a>`;
      } else {
        return match;
      }
    });
  };

  const getDataFromLocalAndDefault = (filter) => {
    let selected_filter = getDataFromStorage("selected_filter", filter);
    let kanban_filter = getDataFromStorage("kanban");

    if (
      typeof kanban_filter !== "object" &&
      typeof kanban_filter !== "undefined"
    ) {
      kanban_filter = JSON.parse(kanban_filter);
    }

    if (kanban_filter) {
      return kanban_filter;
    } else if (selected_filter) {
      return selected_filter;
    } else {
      const [...filterdefault] = filter?.system_filter;

      if (filterdefault) {
        let findisdefaultobj = filterdefault.find(
          (item) => item.is_default === 1
        );
        if (findisdefaultobj) {
          let filterval = {
            [params.attribute_set_key]: findisdefaultobj?.filter_value,
          };
          localStorage.setItem("kanban", JSON.stringify(filterval));
          let newde = getDataFromStorage("default", findisdefaultobj);

          return newde;
        }
      }
    }
  };

  const showIsKanban = () => {
    setState((state) => {
      return {
        ...state,
        isShowKanban: !state.isShowKanban,
      };
    });
  };

  //create view filter

  const enebleClickFilter = (evt, data, isEdit, id) => {
    setState((state) => {
      return {
        ...state,
        enableCustomView: true,
        isEdit: isEdit,
        editFilterId: id,
        editFilterValues: data,
      };
    });
  };

  const handleMenuClickClose = (e) => {
    e.stopPropagation(); // Prevent event from bubbling up
  };

  const filterByPriorityHandler = async (filter_ids, columnId) => {
    const groupBy = getGroupForKanban(params.attribute_set_key) || "priority"
    const { filter_id, columns, assign_to, ...rest } = state.filters;
    let request = {
      app_token: commonData.commonData().appToken,
      attribute_set_key: params.attribute_set_key,
      column_id: columnId,
      group_by: groupBy,
      current_page: 1,
    };

    let newfilters = { ...rest };

    for (let key in newfilters) {
      if (typeof newfilters[key] === "object") {
        delete newfilters[key];
      }
    }

    if (newfilters.hasOwnProperty(columnId)) {
      const { [columnId]: _, ...newrest } = newfilters;
      newfilters = {
        ...newrest,
      };
    }

    if (filter_ids.length) {
      request = {
        ...request,
        columns,
        filters: { priority: filter_ids, ...newfilters },
      };

      setState((state) => {
        const { filters } = state;

        // Create a new object, keeping only non-column keys
        const newFilters = Object.keys(filters)
          .filter((key) => typeof filters[key] !== "object" || key === columnId) // Keep non-column keys or current columnId
          .reduce((obj, key) => {
            obj[key] = filters[key];
            return obj;
          }, {});

        // Add the current columnId with updated data
        newFilters[columnId] = { priority: filter_ids };

        return {
          ...state,
          filters: newFilters,
        };
      });
    } else {
      request = {
        columns,
        ...request,
      };
    }

    if(request.filters && "group_by" in request.filters) delete request.filters.group_by;

    if(request.filters && "search" in request.filters) delete request.filters.search

    const response = await fetch(`${state.api}kanban/filter-kanban-columns`, {
      method: "post",
      body: JSON.stringify(request),
    });

    const rdata = await response.json();

    if (rdata.code === 200) {
      if (state.boarddata.attribute_set_type !== 4) {
        const newdatacards = [...rdata.data];
        setState((state) => {
          return {
            ...state,
            cardData: {
              ...state.cardData,
              [columnId]: newdatacards,
            },
            columnsCount: {
              ...state.columnsCount,
              [columnId]: rdata.total_records,
            },
            currentPage: {
              ...state.currentPage,
              [columnId]: rdata.current_page + 1,
            },
          };
        });
      } else {
        let newcarddata = { ...state.cardData };

        if (
          newcarddata.hasOwnProperty(columnId) &&
          newcarddata[columnId].hasOwnProperty("unpinned")
        ) {
          const getunpinned = [
            // ...newcarddata[columnId]["unpinned"],
            ...rdata.data,
          ];
          newcarddata = {
            ...newcarddata,
            [columnId]: { ...newcarddata[columnId], unpinned: getunpinned },
          };
        } else {
          newcarddata = {
            ...newcarddata,
            [columnId]: { ...newcarddata[columnId], unpinned: [...rdata.data] },
          };
        }

        setState((state) => {
          return {
            ...state,
            cardData: newcarddata,
            hasMore: rdata.data.length === 20,
            columnsCount: {
              ...state.columnsCount,
              [columnId]: rdata.total_records,
            },
            currentPage: {
              ...state.currentPage,
              [columnId]: rdata.current_page + 1,
            },
          };
        });
      }
    } else {
      setState((state) => {
        const newdatacards = [...(rdata.data || [])];
        return {
          ...state,
          cardData: {
            ...state.cardData,
            [columnId]: newdatacards,
          },
          currentPage: {
            ...state.currentPage,
            [columnId]: rdata.current_page + 1,
          },
        };
      });
    }
  };

  const getRawData = async (data, html, draft_js_content, images = []) => {
    const notedata = {
      attribute_set_key: params.attribute_set_key,
      app_token: commonData.commonData().appToken,
      customer_tattle_uuid: state.addNoteData.customer_tattle_uuid,
      user_uuid: commonData.getCommonData().user_uuid,
      note_content: html,
      note_content_json: data,
      attribute_set_type: state.boarddata.attribute_set_type,
      note_type: state.customer_type,
    };

    if (draft_js_content?.length > 0) {
      draft_js_content.forEach((it) => {
        if (it.user_uuid) {
          Object.assign(notedata, {
            mention: (notedata.mention || []).concat(it.user_uuid),
          });
        }
      });
    }

    const response = await fetch(`${state.api}note/create`, {
      method: "post",
      body: JSON.stringify(notedata),
    });

    const rdata = await response.json();
    if (rdata.code == 200) {
      let allnotes = [...state.notes];
      allnotes.push(rdata.data);
      setState((state) => {
        return {
          ...state,
          notes: allnotes || [],
          isLoading: false,
        };
      });
      addNotesHandler({customer_tattle_uuid:state.addNoteData.customer_tattle_uuid});
    }
  };
  useEffect(() => {
    scrollRef?.current?.scrollIntoView();
  }, [scrollRef, state.notes]);

  const addNotesHandler = (data=null, evt=null) => {
    evt?.stopPropagation();
    setState((state) => {
      return {
        ...state,
        showTodoNote: true,
        notes: [],
        addNoteData: {
          ...data,
        },
        isLoading: true,
      };
    });

    (async () => {
      let jsondata = {
        app_token: commonData.commonData().appToken,
        attribute_set_key: params.attribute_set_key,
        attribute_set_type: state.boarddata.attribute_set_type,
        customer_tattle_uuid: data.customer_tattle_uuid,
        order: "asc",
      };
      const resp = await fetch(`${state.api}notes/list`, {
        method: "post",
        body: JSON.stringify(jsondata),
      });
      const rdata = await resp.json();
      if (rdata.code === 200) {
        setState((state) => {
          return {
            ...state,
            notes: rdata.data,
            isLoading: false,
          };
        });
      } else {
        setState((state) => {
          return {
            ...state,
            notes: [],
            isLoading: false,
          };
        });
      }
    })();
  };

  const callTheApiDefaut = async (
    filterdata = null,
    boarddata = null,
    showColumns = []
  ) => {
    
    const group = (getGroupForKanban(params.attribute_set_key) || "priority")
    let { group_by, filter_id, ...rest } = {
      // ...state.filters,
      ...filterdata,
    };
    let getfilterId = localStorage.getItem("selected_filter");
    let getid = "";
    if (getfilterId) {
      getfilterId = JSON.parse(getfilterId);
      getid =
        getfilterId[
          state.boarddata.attribute_set_key || boarddata.attribute_set_key
        ];
    }
    let requestData = {};
    if (checkViewType() === "backlog") {
      requestData = {
        ...requestData,
        group_by: group,
        // advance_filter,
      };
    }
    if (filter_id) {
      requestData = {
        app_token: commonData.commonData().appToken,
        filter_id: filter_id || "",
        user_uuid: userdetails.userId,
        attribute_set_key: params.attribute_set_key,
        attribute_set_type:
          state?.boarddata?.attribute_set_type || boarddata?.attribute_set_type,
        filters: {
          ...rest,
        },
        group_by:group,
      };
    } else if (
      filterdata?.hasOwnProperty("filter_view") &&
      filterdata.filter_view
    ) {
      let { filter_view, group_by, ...rest } = filterdata;
      requestData = {
        app_token: commonData.commonData().appToken,
        attribute_set_key: params.attribute_set_key,
        filter_id: getid || filter_id || "",
        user_uuid: userdetails.userId,
        attribute_set_type:
          state?.boarddata?.attribute_set_type || boarddata?.attribute_set_type,

        filters: {
          ...rest,
        },
        group_by: group,
      };
    } else {
      if (!state.isResetFilter) {
        let { group_by, filter_id, advance_filter, ...rest } = {
          ...state.filters,
          ...filterdata,
        };
      } else {
        let { group_by, filter_id, advance_filter, ...rest } = {
          ...filterdata,
        };
      }
      requestData = {
        app_token: commonData.commonData().appToken,
        attribute_set_key: params.attribute_set_key,
        attribute_set_type:
          state?.boarddata?.attribute_set_type || boarddata?.attribute_set_type,
        filter_id: getid || filter_id || "",
        user_uuid: userdetails.userId,
        filters: {
          ...rest,
        },
        group_by:group,
        ...requestData,
      };
    }
    setState((state) => {
      return {
        ...state,
        isFetching: true,
      };
    });
    let {
      filters: { filter_view, ...newdata },
      ...allrst
    } = requestData;
    if (!filterdata?.hasOwnProperty("range")) {
      newdata = {
        ...delete newdata["range"],
        ...newdata,
      };
    }

    let advance_filter_local = localStorage.getItem("advance_filter");
    let newpayloadfoeadvancefilter = {
      filters: newdata,
      ...allrst,
      ...((boarddata?.attribute_set_type === 4 ||
        state.boarddata.attribute_set_type === 4) && { pin: true }),
    };
    if (advance_filter_local) {
      let local_filter_stringify = JSON.parse(advance_filter_local);
      let localfileParsed = local_filter_stringify[params.attribute_set_key];

      newpayloadfoeadvancefilter = {
        advance_filter: localfileParsed,
        ...newpayloadfoeadvancefilter,
      };
    }

    if (showColumns.length) {
      newpayloadfoeadvancefilter = {
        ...newpayloadfoeadvancefilter,
        columns: [...showColumns],
        group_by: group,
      };
    }

    if (state.globalSearch) {
      
      const { group_by, columns, ...rest } = state.filters;
      newpayloadfoeadvancefilter = {
        ...newpayloadfoeadvancefilter,
        search: state.globalSearch,
      filters: getformatdata(deepCleanObject({ ...newpayloadfoeadvancefilter.filters, ...rest })) ?? {},
         group_by: group,
      };

      if(showColumns.length) {
        newpayloadfoeadvancefilter = {
          ...newpayloadfoeadvancefilter,
          columns:showColumns
        }
      }else {
        newpayloadfoeadvancefilter = {
          ...newpayloadfoeadvancefilter,
          columns:columns
        }
      }
    }
    setGroupByForkanban(group, params.attribute_set_key)

    if(newpayloadfoeadvancefilter.filters && "columns" in newpayloadfoeadvancefilter.filters) delete newpayloadfoeadvancefilter.filters.columns
    if(newpayloadfoeadvancefilter && "filter_id" in newpayloadfoeadvancefilter) delete newpayloadfoeadvancefilter.filter_id

    
    if(newpayloadfoeadvancefilter.filters && "search" in newpayloadfoeadvancefilter.filters) {
      const {search} = newpayloadfoeadvancefilter.filters

      newpayloadfoeadvancefilter.search =  search

      delete newpayloadfoeadvancefilter.filters.search
    }

    
    // return;
    const resp = await fetch(`${state.api}/kanban/get-kanban-rows`, {
      method: "POST",
      body: JSON.stringify(deepCleanObject(newpayloadfoeadvancefilter)),
    });
    const rdata = await resp.json();
    let assignes = [];

    if (group_by === "assign_to") {
      const assignkeys = Object?.keys(rdata?.data ?? {});
      assignes = assignkeys;
    } else {
      assignes = filterdata?.assign_to;
    }
    if (rdata.code === 200) {
      const values = {};
      setState((state) => {
        return {
          ...state,
          isResetFilter: false,
          total_count: rdata.counts && Object.values(rdata.counts).reduce((sum, val) => sum + val, 0),
          cardData: rdata.data,
          isFetching: false,
          isCallingApi: false,
          assignUsers: assignes,
          filters: {
            ...state.filters,
            ...filterdata,
          },
          hasMore: rdata.data.length === 20,
          showColumnsArray: [...Object.keys(rdata.data)],
          columnsCount: { ...rdata.counts },
        };
      });
    } else {
      setState((state) => {
        return {
          ...state,
          isFetching: false,
          cardData: [],
        };
      });
    }
  };
  const customStylesNew = {
    control: (provided, state) => ({
      ...provided,
      boxShadow: "none",
      borderRadius: "none",
      // border: "none",

      "&:focus": {
        border: state.isFocused ? "none" : 0,
        boxShadow: state.isFocused ? "none" : null,
        borderColor: state.isFocused ? "none" : provided.borderColor,
      },
    }),
    menu: (pro) => {
      return {
        ...pro,
        // height: 250,
        overflowY: "hidden",
        zIndex: 999999,
      };
    },
  };

  const customStyles = {
    control: (provided, state) => ({
      ...provided,
      boxShadow: "none",
      border: "none",

      "&:focus": {
        border: state.isFocused ? "none" : 0,
        boxShadow: state.isFocused ? "none" : null,
        borderColor: state.isFocused ? "none" : provided.borderColor,
      },
    }),
    menu: (pro) => {
      return {
        ...pro,
        height: 250,
        overflowY: "hidden",
      };
    },
  };
  const clearFormDataFilter = (field) => {
    const newfilters = { ...state.filters };
    if (
      newfilters.hasOwnProperty("range") &&
      newfilters["range"].hasOwnProperty(field)
    ) {
      delete newfilters["range"];
    }
    setState((state) => {
      return {
        ...state,
        filters: newfilters,
      };
    });
  };

  const getPinnedUi = (columns, data) => {
    const totalPinnedCount = getTotalPinnedCount(data);
    const pinned = columns.find((item) => item.field === "pin");
    return pinned &&
      commonData.commonData().userId === data?.assign_to &&
      totalPinnedCount < 2 ? (
      <span
        className={`notesbtn ${data?.pin === true ? "pinnedactive" : ""}`}
        onClick={
          commonData.commonData().userId === data.assign_to
            ? pinnedHandler.bind(this, data)
            : undefined
        }
      >
        <svg
          width="26"
          height="26"
          viewBox="0 0 26 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect
            x="0.5"
            y="0.5"
            width="25"
            height="25"
            rx="12.5"
            stroke="black"
            stroke-opacity="0.1"
          />
          <path
            d="M6.89773 10.8317V9.72727H12.7003V10.8317H10.4524V17H9.1456V10.8317H6.89773ZM13.6699 17V16.0483L16.1947 13.5732C16.4362 13.3293 16.6374 13.1127 16.7984 12.9233C16.9594 12.7339 17.0801 12.5504 17.1606 12.3729C17.2411 12.1953 17.2814 12.0059 17.2814 11.8047C17.2814 11.575 17.2293 11.3786 17.1251 11.2152C17.021 11.0495 16.8777 10.9216 16.6954 10.8317C16.5131 10.7417 16.306 10.6967 16.074 10.6967C15.8349 10.6967 15.6254 10.7464 15.4454 10.8459C15.2655 10.9429 15.1258 11.0814 15.0264 11.2614C14.9293 11.4413 14.8808 11.6555 14.8808 11.9041H13.6273C13.6273 11.4425 13.7326 11.0412 13.9433 10.7003C14.154 10.3594 14.444 10.0954 14.8133 9.90838C15.185 9.72135 15.6112 9.62784 16.0917 9.62784C16.5794 9.62784 17.0079 9.71899 17.3773 9.90128C17.7466 10.0836 18.033 10.3333 18.2366 10.6506C18.4426 10.9678 18.5456 11.33 18.5456 11.7372C18.5456 12.0095 18.4935 12.277 18.3893 12.5398C18.2852 12.8026 18.1017 13.0937 17.8389 13.4134C17.5785 13.733 17.2127 14.12 16.7416 14.5746L15.4881 15.8494V15.8991H18.6557V17H13.6699Z"
            fill="#404040"
          />
        </svg>
      </span>
    ) : data?.hasOwnProperty("pin") && data?.pin == true ? (
      <span
        className={`notesbtn ${
          commonData.commonData().userId === data.assign_to
            ? "pinnedactive"
            : "pinnedactivated"
        }`}
        onClick={
          commonData.commonData().userId === data.assign_to
            ? pinnedHandler.bind(this, data)
            : undefined
        }
      >
        <svg
          width="26"
          height="26"
          viewBox="0 0 26 26"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
        >
          <rect width="26" height="26" rx="13" fill="#00BF2A" />
          <rect
            x="0.5"
            y="0.5"
            width="25"
            height="25"
            rx="12.5"
            stroke="#00BF2A"
            stroke-opacity="0.06"
          />
          <path
            d="M6.89773 10.8317V9.72727H12.7003V10.8317H10.4524V17H9.1456V10.8317H6.89773ZM13.6699 17V16.0483L16.1947 13.5732C16.4362 13.3293 16.6374 13.1127 16.7984 12.9233C16.9594 12.7339 17.0801 12.5504 17.1606 12.3729C17.2411 12.1953 17.2814 12.0059 17.2814 11.8047C17.2814 11.575 17.2293 11.3786 17.1251 11.2152C17.021 11.0495 16.8777 10.9216 16.6954 10.8317C16.5131 10.7417 16.306 10.6967 16.074 10.6967C15.8349 10.6967 15.6254 10.7464 15.4454 10.8459C15.2655 10.9429 15.1258 11.0814 15.0264 11.2614C14.9293 11.4413 14.8808 11.6555 14.8808 11.9041H13.6273C13.6273 11.4425 13.7326 11.0412 13.9433 10.7003C14.154 10.3594 14.444 10.0954 14.8133 9.90838C15.185 9.72135 15.6112 9.62784 16.0917 9.62784C16.5794 9.62784 17.0079 9.71899 17.3773 9.90128C17.7466 10.0836 18.033 10.3333 18.2366 10.6506C18.4426 10.9678 18.5456 11.33 18.5456 11.7372C18.5456 12.0095 18.4935 12.277 18.3893 12.5398C18.2852 12.8026 18.1017 13.0937 17.8389 13.4134C17.5785 13.733 17.2127 14.12 16.7416 14.5746L15.4881 15.8494V15.8991H18.6557V17H13.6699Z"
            fill="white"
          />
        </svg>
      </span>
    ) : (
      ""
    );
  };

  const mergePinnedData = (info) => {
    let getdata = (getGroupForKanban(params.attribute_set_key) || "priority")
    let mergedPinned = [];
    const newdata = Object.values(state.cardData);
    for (let key of newdata) {
      if (key.pinned) {
        mergedPinned.push(...key.pinned.map((it) => it));
      }
    }

    const data = state.cardData[info[getdata]];

    return mergedPinned.filter(
      (it) => it.assign_to === commonData.commonData().userId
    );
  };
  const getTotalPinnedCount = (data) => {
    const mergedata = mergePinnedData(data);
    return mergedata.length;
  };
  //apply custom view filter

  const applyFilterHandler = (item) => {
    const allFilters = [...state.filterView];
    const { value } = item;
    const getFilters = allFilters.find(
      (it) => it.filter_id == value
    )?.filter_value;
    const parseData = JSON.parse(getFilters);
    setState((state) => {
      return {
        ...state,
        filters: {
          ...state.filters,
          assign_to: parseData?.assign_to,
          group_by: parseData?.group_by,
        },
      };
    });
  };


  const removeFilterHandler = (id) => {
    setState((state) => {
      return { ...state, isFilterRemove: true, removeFilterId: id };
    });
  };

  // hide field

  const showHideAttribute = () => {
    setState((state) => {
      return {
        ...state,
        showAllattribute: !state.showAllattribute,
      };
    });
  };

  const groupChangeHandler = (evt) => {
    const { group_by, ...rest } = state.filters;
    setState((state) => {
      return {
        ...state,
        filters: {
          ...rest,
        },
        newOptionColumns: [],
        explicitGroupChange: evt.value,
      };
    });
    setGroupByForkanban(evt.value, params.attribute_set_key)
    callTheApiDefaut({ ...rest, group_by: evt.value });
  };

  const searchGrid = (event) => {
    const { name, value } = event.target;

    setState((state) => {
      return {
        ...state,
        globalSearch: value,
      };
    });
     };
    
      const resetAllFilter = () => {
        setState((state) => {
          return {
            ...state,
            filters: {},
            isResetFilter: true,
            globalSearch: "",
          };
        });
      
        cleearFilterFromStorage("clear");
      
        // 🔥 Trigger API manually using flag
        setTriggerApiCall(true);
      };
      
      useEffect(() => {
        if (!triggerApiCall && !state.globalSearch) return;

    if (timeframe.current) {
      clearTimeout(timeframe.current);
    }

    timeframe.current = setTimeout(() => {
      callTheApiDefaut();
      setTriggerApiCall(false); // reset the flag
    }, 500);
  }, [state.globalSearch, triggerApiCall]);
  const menuRender = (menu) => {
    // Manually render the menu if necessary, for example:
    return <div ref={refgroupcategoryMain}>{menu}</div>;
  };

  // form submit to create new item or edit

  const formSubmitHandler = async (values, pin) => {
    let getdata = (getGroupForKanban(params.attribute_set_key) || "priority")
    setState((state) => {
      return {
        ...state,
        isSubmitting: true,
      };
    });
    if (state.editId) {
      const newvalues = Object.assign(
        { customer_tattle_uuid: state.editId },
        { ...values },
        {
          attribute_set_key: params.attribute_set_key,
          app_token: commonData.commonData().appToken,
          user_uuid: commonData.commonData().userId,
        }
      );

      const response = await fetch(`${state.api}tattle/update`, {
        method: "POST",
        body: JSON.stringify(newvalues),
      });
      const rdata = await response.json();
      if (rdata.code == 200) {
        const getcarddata = state.cardData;
        const newdatacardval =
          getcarddata[values[getdata]][pin ? "pinned" : "unpinned"];
        if (state.user_uuid !== values[getdata]) {
          let removecard =
            getcarddata[state.user_uuid][pin ? "pinned" : "unpinned"];
          let newtrasform = removecard.filter(
            (item) => item.customer_tattle_uuid !== state.editId
          );
          setState((state) => {
            return {
              ...state,
              cardData: {
                ...state.cardData,
                [state.user_uuid]: {
                  [pin ? "pinned" : "unpinned"]: newtrasform,
                  ...(pin
                    ? state.cardData[state.user_uuid]["unpinned"]
                    : state.cardData[state.user_uuid]["pinned"]),
                },
              },
            };
          });
        }
        if (newdatacardval) {
          if (state.user_uuid !== values[getdata]) {
            let getdatafil = getcarddata[state.user_uuid][
              pin ? "pinned" : "unpinned"
            ].find((it) => it.customer_tattle_uuid == state.editId);
            let newvalfil = { ...getdatafil, ...newvalues };
            newdatacardval.unshift(newvalfil);
          }
          let newtransformdata = newdatacardval?.map((item) => {
            if (item.customer_tattle_uuid === state.editId) {
              return {
                ...item,
                ...values,
              };
            }

            return item;
          });

          setState((state) => {
            return {
              ...state,
              cardData: {
                ...state.cardData,
                [values[getdata]]: {
                  [pin ? "pinned" : "unpinned"]: newtransformdata,
                  ...(pin
                    ? { unpinned: state.cardData[values[getdata]]["unpinned"] }
                    : { pinned: state.cardData[values[getdata]]["pinned"] }),
                },
              },
              isSubmitting: false,
              editShowCanvas: false,
              // createBoard: {
              //   ...state.createBoard,
              //   board: true,
              //   message: rdata.message,
              //   title: rdata.status,
              // },
            };
          });
        } else {
          const statedata = { ...state.cardData };

          const getval =
            statedata[state.user_uuid][pin ? "pinned" : "unpinned"];
          let newcardval = getval.map((it) => {
            if (it.customer_tattle_uuid == state.editId) {
              return { ...it, [getdata]: values[getdata] };
            } else {
              return it;
            }
          });
          let newtrasnformdata = newcardval.map((item) => {
            if (item[getdata] == state.user_uuid) {
              return { ...item };
            } else {
              return;
            }
          });
          let checkval = newtrasnformdata.filter(
            (it) => it !== null && it !== undefined
          );

          setState((state) => {
            return {
              ...state,
              cardData: {
                ...state.cardData,
                [state.user_uuid]: {
                  [pin ? "pinned" : "unpinned"]: checkval,
                  ...(pin
                    ? state.cardData[state.user_uuid]["unpinned"]
                    : state.cardData[state.user_uuid]["pinned"]),
                },
              },
              isSubmitting: false,
              editShowCanvas: false,
              // createBoard: {
              //   ...state.createBoard,
              //   board: true,
              //   message: rdata.message,
              //   title: rdata.status,
              // },
            };
          });
        }
      }
    } else {
      values = {
        ...values,
        ...defaultUserLogin.current,
        ...(state.boarddata.attribute_set_type == 4 &&
          values?.completed == "" && {
            completed: "false",
          }),
      };
      let listing_form_submit = {
        ...values,
        app_token: commonData.commonData().appToken,
        user_uuid: commonData.commonData().userId,
        attribute_set_key: params.attribute_set_key,
        attribute_set_type: state.boarddata.attribute_set_type,
      };

      let getassign = listing_form_submit[getdata];

      const response = await fetch(`${state.api}tattle/create`, {
        method: "post",
        headers: {
          "Content-Type": "application/json",
        },
        body: JSON.stringify(listing_form_submit),
      });
      const rdata = await response.json();
      if (rdata.code == 200) {
        if (!state.cardData.hasOwnProperty(getassign)) {
          setState((state) => {
            const newData = { ...state.cardData };
            const existingData = newData[getassign];

            // Check if existingData is an array and is defined
            if (!Array.isArray(existingData)) {
              newData[getassign] = {
                ...state.cardData,
                unpinned: [{ ...listing_form_submit, ...rdata.data }],
              };
            } else {
              newData[getassign] = {
                ...state.cardData,
                unpinned: [...existingData, { ...listing_form_submit }],
              };
            }

            return {
              ...state,
              isSubmitting: false,
              showAddCanvas: false,
              cardData: newData,
            };
          });
        } else {
          if (
            state.cardData[rdata?.data?.[getdata]].hasOwnProperty("unpinned")
          ) {
            const getcardData =
              state.cardData[rdata?.data?.[getdata]]["unpinned"];
            getcardData?.unshift(rdata?.data);
            setState((state) => {
              return {
                ...state,
                isSubmitting: false,
                showAddCanvas: false,
                cardData: {
                  ...state.cardData,
                  [rdata?.data?.[getdata]]: {
                    ...state.cardData[rdata?.data?.[getdata]],
                    unpinned: getcardData,
                  },
                },
              };
            });
          } else {
            let getcardData = state.cardData[rdata?.data?.[getdata]];
            getcardData = { unpinned: [rdata?.data] };

            setState((state) => {
              return {
                ...state,
                isSubmitting: false,
                showAddCanvas: false,
                cardData: {
                  ...state.cardData,
                  [rdata?.data?.[getdata]]: {
                    ...state.cardData[rdata?.data?.[getdata]],
                    ...getcardData,
                  },
                },
              };
            });
          }
        }
      }
    }
  };

  const showAttributeListDropDown = () => {
    setState((state) => {
      return {
        ...state,
        showattrdrop: true,
      };
    });
  };

  const clearBulkAction = () => {
    setState((state) => {
      return {
        ...state,
        assignToReleaseData: [],
      };
    });
  };

  const submitBulkUpdate = async (data) => {
    setState((state) => {
      return {
        ...state,
        isBulkUpload: true,
      };
    });

    const resp = await fetch(`${state.api}tattle/bulk-update`, {
      method: "POST",
      body: JSON.stringify({
        ...data,
        app_token: commonData.commonData().appToken,
        user_uuid: commonData.commonData().userId,
        attribute_set_key: params.attribute_set_key,
      }),
    });

    const rdata = await resp.json();

    if (rdata.code === 200) {
      setState((state) => {
        return {
          ...state,
          isBulkUpload: false,
          hideattrdrop: false,
          assignToReleaseData: [],
        };
      });
      callTheApiDefaut(state.filters);
    }
  };

  const hideattrdrop = () => {
    setState((state) => {
      return {
        ...state,
        showattrdrop: false,
      };
    });
  };

  const renderDragableCardItemPinned = (item, column) => {

    const getdata =  getGroupForKanban(params.attribute_set_key) || "priority"
    return (
      <div
        style={{
          userSelect: "none",

          margin: "0 0 8px",
          minHeight: "50px",
          backgroundColor: "#fff",
          color: "#000",
          borderRadius: "5px",
          whiteSpace: "break-spaces",
          wordBreak: "break-all",
          boxShadow:
            "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)",
          // ...provided.draggableProps.style,
          cursor: "not-allowed",
        }}
        onClick={() =>
          state.boarddata.attribute_set_type === 4
            ? onDragEditHandler(
                item[getdata],
                item.customer_tattle_uuid
                // pinnedData
              )
            : null
        }
      >
        <div className="main_section">
          {getFormFieldWithValue(state.columns, item)}
        </div>
      </div>
    );
  };

  const showBackLogFilterHandler = () => {
    setState((state) => {
      return {
        ...state,
        showbacklogFilter: true,
      };
    });
  };

  const getDragUi = (column, id, cindex) => {
    const groupBy = getGroupForKanban(params.attribute_set_key) || "priority"
    if (state.boarddata.attribute_set_type === 4) {
      return (
        <Draggable key={id} index={cindex}>
          {(provided) => {
            return (
              <div
                {...provided.draggableProps}
                ref={provided.innerRef}
                className="mainDropColumn"
              >
                {" "}
                <div>
                  <div className="backlog_header">
                    <h6
                      style={{
                        margin: 10,
                        color: "#000",
                        cursor: "grab",
                      }}
                    >
                      {getNameByGroupName(id)}
                    </h6>

                    <div className="backlog_child_class">
                      { groupBy !== "priority" && (
                        <BackLogFilter
                          columns={state.columns}
                          column_id={id}
                          filterByPriorityHandler={filterByPriorityHandler}
                        />
                      )}
                      <div className="simepleId">{`${
                        state.columnsCount[id] || 0
                      }`}</div>
                    </div>
                  </div>

                  <InfiniteScroll
                    dataLength={
                      column.hasOwnProperty("unpinned")
                        ? column?.["unpinned"].length
                        : column.hasOwnProperty("pinned") &&
                          column?.["pinned"].length
                    }
                    next={() => callingForNewRecord(id)}
                    hasMore={
                      column.hasOwnProperty("unpinned")
                        ? column?.["unpinned"].length
                        : column.hasOwnProperty("pinned") &&
                          column?.["pinned"].length !== state.columnsCount[id]
                    }
                    height={"calc(100vh - 238px)"}
                    scrollThreshold={0.95}
                  >
                    <div
                      style={{
                        margin: "8px",
                        overflowY: "auto",
                        height:
                        column?.pinned?.length === 2
                        ?"calc(100% - 120px)"
                        : "calc(100% - 20px)",
                      }}
                      className={`newchck ${
                        params.attribute_set_key === "todo" ? "addheight" : ""
                      }`}
                    >
                      <Droppable droppableId={id} ref={dropdowmScroll}>
                        {(provided, snapshot) => {
                          return (
                            <div
                              {...provided.droppableProps}
                              ref={provided.innerRef}
                              scroll
                              style={{
                                padding: 4,
                                height: "100%",
                                // overflowY: "auto",
                                // overflowX: "hidden",
                              }}
                            >
                              <div>
                                {column?.pinned?.map((item, ind) => {
                                  return (
                                    <div
                                      key={item?.customer_tattle_uuid}
                                      index={ind}
                                    >
                                      {renderDragableCardItemPinned(
                                        item,
                                        column
                                      )}
                                    </div>
                                  );
                                })}{" "}
                              </div>
                              {column?.unpinned || [].length > 0
                                ? column?.unpinned?.map((item, ind) => {
                                    return (
                                      <Draggable
                                        key={item?.customer_tattle_uuid}
                                        draggableId={String(
                                          item?.customer_tattle_uuid
                                        )}
                                        index={ind}
                                        direction="horizontal"
                                        isDragDisabled={onDragCardHandler(
                                          column
                                        )}
                                      >
                                        {renderDragableCardItem(
                                          provided,
                                          snapshot,
                                          item,
                                          column,
                                          state.cardData[
                                            item[groupBy]
                                          ]?.pinned
                                        )}
                                      </Draggable>
                                    );
                                  })
                                : ""}
                              
                              {provided.placeholder}
                              {column?.length == 0 ||
                              column?.["unpinned"]?.length == 0 ? (
                                <div className="placeholderimage">
                                  {provided.placeholder}
                                  <NoRecord />

                                  <div class="title_no_record">
                                    No Record found
                                  </div>
                                </div>
                              ) : (
                                ""
                              )}
                            </div>
                          );
                        }}
                      </Droppable>
                    </div>
                  </InfiniteScroll>
                </div>
                <div className="addbuttonitem mb-2">
                  {state.boarddata.attribute_set_type == 4 && (
                    <button
                      className="kan_btn"
                      onClick={() => addNewItemHandler(id)}
                    >
                      +
                    </button>
                  )}
                </div>
              </div>
            );
          }}
        </Draggable>
      );
    }
    return (
      <Draggable key={id} index={cindex}>
        {(provided) => {
          return (
            <div
              {...provided.draggableProps}
              ref={provided.innerRef}
              className="mainDropColumn"
            >
              <div>
                <div className="backlog_header">
                  <h6
                    style={{
                      margin: 10,
                      color: "#000",
                      cursor: "grab",
                    }}
                  >
                    {getNameByGroupName(id)}
                  </h6>
                  <div className="backlog_child_class">
                    {groupBy !== "priority" && (
                      <BackLogFilter
                        columns={state.columns}
                        column_id={id}
                        filterByPriorityHandler={filterByPriorityHandler}
                      />
                    )}

                    <div className="simepleId">{`${
                      state.columnsCount[id] || 0
                    }`}</div>
                  </div>
                </div>

                <InfiniteScroll
                  dataLength={column.length}
                  next={() => callingForNewRecord(id)}
                  hasMore={column.length !== state.columnsCount[id]}
                  height={"calc(100vh - 238px)"}
                  scrollThreshold={0.95}
                >
                  <div
                    style={{
                      margin: "8px",
                      overflow: "hidden",
                      height:
                        column?.pinned?.length === 2
                          ? { height: "calc(84% - 187px)" }
                          : { height: "calc(84% - 87px)" },
                    }}
                    className={`newchck ${
                      params.attribute_set_key === "todo" ? "addheight" : ""
                    }`}
                  >
                    <Droppable droppableId={id} ref={dropdowmScroll}>
                      {(provided, snapshot) => {
                        return (
                          <div
                            {...provided.droppableProps}
                            ref={provided.innerRef}
                            scroll
                            style={{
                              padding: 4,
                              height: "100%",
                              // overflowY: "auto",
                              // overflowX: "hidden",
                            }}
                          >
                            {column?.map((item, ind) => {
                              return (
                                <Draggable
                                  key={item?.customer_tattle_uuid}
                                  draggableId={String(
                                    item?.customer_tattle_uuid
                                  )}
                                  index={ind}
                                  direction="horizontal"
                                  isDragDisabled={onDragCardHandler(column)}
                                >
                                  {renderDragableCardItem(
                                    provided,
                                    snapshot,
                                    item,
                                    column,
                                    state.cardData[item[groupBy]]
                                      ?.pinned
                                  )}
                                </Draggable>
                              );
                            })}
                            {provided.placeholder}
                            {column?.length == 0 ? (
                              <div className="placeholderimage">
                                {provided.placeholder}
                                <NoRecord />

                                <div class="title_no_record">
                                  No Record found
                                </div>
                              </div>
                            ) : (
                              ""
                            )}
                          </div>
                        );
                      }}
                    </Droppable>
                  </div>
                </InfiniteScroll>
              </div>
              <div className="addbuttonitem mb-2">
                {params.attribute_set_key == "todo-3" && (
                  <button
                    className="kan_btn"
                    onClick={() => addNewItemHandler(id)}
                  >
                    +
                  </button>
                )}
              </div>
            </div>
          );
        }}
      </Draggable>
    );
  };

  const canvasCloseHandler = () => {
    setState((state) => {
      return {
        ...state,
        showTodoNote: false,
        customer_type: "internal",
      };
    });
  };

  // disable the drag and drop by certain condition

  const onDragCardHandler = (column) => {
    const groupBy = getGroupForKanban(params.attribute_set_key) || "priority"
    if (column.length > 100) {
      return true;
    } else if (
      (groupBy !== "assign_to" &&
        state.filters?.assign_to?.length > 1) ||
      state.filters.assign_to?.length === 0
    ) {
      return true;
    } else return false;
  };

  // get hidden field

  const getHiddenFormFieldValue = (formik, item, index, focusRef) => {
    const groupBy = getGroupForKanban(params.attribute_set_key) || "priority"
    if (item.attribute_type === "text") {
      return (
        <Col md={12} className="mb-3">
          <div className="inputbox-group">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >{`${commonData.firstUpper(item.headerName)}`}</label>
            <input
              type={item.attribute_type}
              ref={(el) => {
                clearform = el;
                focusRef.current[index] = el;
              }}
              placeholder={`${item.headerName}`}
              name={item.field}
              onChange={formik.handleChange}
              value={formik.values[item.field]}
              className={`input-cls form-control ${
                item.is_required && "required"
              }`}
              autocomplete={"off"}
              onBlur={() => formik.setFieldTouched(item.field, true)}
            />
            {item?.min_length &&
              formik.values[item.field] &&
              formik.touched[item.field] &&
              formik.values[item.field].replace(/<[^>]+>/g, "").trim().length <
              Number(item.min_length) && (
                <p className="input-warning">
                  <i className="fas fa-exclamation-triangle"></i>
                  The recommended {item.headerName.toLowerCase()} length is at least{" "}
                  {item.min_length} characters.
                </p>
              )}
            <Bform.Control.Feedback
              type="invalid"
              style={
                formik.errors[item.field] && formik.touched[item.field]
                  ? {
                      display: "block",
                    }
                  : {}
              }
            >
              {formik.errors[item.field] && formik.touched[item.field] ? (
                <div class="error">{formik.errors[item.field]}</div>
              ) : null}
            </Bform.Control.Feedback>
          </div>
        </Col>
      );
    }

    if (item.attribute_type === "email") {
      return (
        <Col md={12} className="mb-3">
          <div className="inputbox-group">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >{`${commonData.firstUpper(item.headerName)}`}</label>
            <input
              type={item.attribute_type}
              ref={(el) => (clearform = el)}
              placeholder={`${item.headerName}`}
              name={item.field}
              onChange={formik.handleChange}
              value={formik.values[item.field]}
              className={`form-control mb-3 ${item.is_required && "required"}`}
              autoComplete={"off"}
            />

            <Bform.Control.Feedback
              type="invalid"
              style={
                formik.errors[item.field] && formik.touched[item.field]
                  ? {
                      display: "block",
                    }
                  : {}
              }
            >
              {formik.errors[item.field] && formik.touched[item.field] ? (
                <div class="error">{formik.errors[item.field]}</div>
              ) : null}
            </Bform.Control.Feedback>
          </div>
        </Col>
      );
    }
    if (item.attribute_type === "company_name") {
      return (
        <Col md={12} className="mb-3">
          <div className="inputbox-group">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >{`${commonData.firstUpper(item.headerName)}`}</label>
            <input
              type={item.attribute_type}
              ref={(el) => (clearform = el)}
              placeholder={`${item.headerName}`}
              name={item.field}
              onChange={formik.handleChange}
              value={formik.values[item.field]}
              className={`form-control mb-3 ${item.is_required && "required"}`}
              autoComplete={"off"}
            />

            <Bform.Control.Feedback
              type="invalid"
              style={
                formik.errors[item.field] && formik.touched[item.field]
                  ? {
                      display: "block",
                    }
                  : {}
              }
            >
              {formik.errors[item.field] && formik.touched[item.field] ? (
                <div class="error">{formik.errors[item.field]}</div>
              ) : null}
            </Bform.Control.Feedback>
          </div>
        </Col>
      );
    }
    if (item.attribute_type === "customer_type") {
      return (
        <Col md={12} className="mb-3">
          <div className="inputbox-group">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >{`${commonData.firstUpper(item.headerName)}`}</label>
            <input
              type={item.attribute_type}
              ref={(el) => (clearform = el)}
              placeholder={`${item.headerName}`}
              name={item.field}
              onChange={formik.handleChange}
              value={formik.values[item.field]}
              className={`form-control mb-3 ${item.is_required && "required"}`}
              autoComplete={"off"}
            />

            <Bform.Control.Feedback
              type="invalid"
              style={
                formik.errors[item.field] && formik.touched[item.field]
                  ? {
                      display: "block",
                    }
                  : {}
              }
            >
              {formik.errors[item.field] && formik.touched[item.field] ? (
                <div class="error">{formik.errors[item.field]}</div>
              ) : null}
            </Bform.Control.Feedback>
          </div>
        </Col>
      );
    }
    if (item.attribute_type === "monitoring") {
      let values = [];
      if (formik.values) {
        values = state.activeUsers.filter(
          (it) => it.value && formik.values[item.field].includes(it.value)
        );
      }
      return (
        <Col md={12} className="mb-3">
          <div className="inputbox-group">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >{`${commonData.firstUpper(item.headerName)}`}</label>
            <AsyncSelect
              cacheOptions
              defaultOptions
              maxMenuHeight={175}
              menuPlacement="auto"
              isMulti={true}
              components={{ Option: CustomOption }}
              name="label"
              placeholder={commonData.firstUpper(item.headerName)}
              value={values}
              // isClearable={true}
              loadOptions={(evt) =>
                getPeoplesCall(evt, item.api_url, state, setState)
              }
              onChange={(value) => {
                formik.setFieldValue(
                  item.field,
                  !value
                    ? ""
                    : Array.isArray(value)
                    ? value.map((item) => item.value)
                    : value.value
                );
              }}
              onBlur={() => formik.setFieldTouched(item.field, true)}
            />
            <Bform.Control.Feedback
              type="invalid"
              style={
                formik.errors[item.field] && formik.touched[item.field]
                  ? {
                      display: "block",
                    }
                  : {}
              }
            >
              {formik.errors[item.field] && formik.touched[item.field] ? (
                <div class="error">{formik.errors[item.field]}</div>
              ) : null}
            </Bform.Control.Feedback>
          </div>
        </Col>
      );
    }
    if (item.attribute_type === "age") {
      return (
        <Col md={12} className="mb-3">
          <div className="inputbox-group">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >{`${commonData.firstUpper(item.headerName)}`}</label>
            <input
              type={item.attribute_type}
              ref={(el) => (clearform = el)}
              placeholder={`${item.headerName}`}
              name={item.field}
              onChange={formik.handleChange}
              value={formik.values[item.field]}
              className={`form-control mb-3 ${item.is_required && "required"}`}
              autoComplete={"off"}
            />
            <Bform.Control.Feedback
              type="invalid"
              style={
                formik.errors[item.field] && formik.touched[item.field]
                  ? {
                      display: "block",
                    }
                  : {}
              }
            >
              {formik.errors[item.field] && formik.touched[item.field] ? (
                <div class="error">{formik.errors[item.field]}</div>
              ) : null}
            </Bform.Control.Feedback>
          </div>
        </Col>
      );
    }
    if (item.attribute_type === "checkbox") {
      return "";
    }

    if (item.headerName !== undefined && item.attribute_type === "textarea") {
      return (
        <Col md={12} className="mb-3 ck_editing">
          <div className="inputbox-group mb-3">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >{`${commonData.firstUpper(item.headerName)}`}</label>

            <DraftjsInline
              key={item.field}
              editorState={formik.values[item.field] || ""}
              field={item.field}
              ref={(el) => (focusRef.current[index] = el)}
              formik={formik}
              onChange={(newEditorState) => {
                formik.setFieldValue(item.field, newEditorState);
              }}
              onBlur={() => {
                formik.setFieldTouched(item.field, true);
              }}
            />
            {item?.min_length &&
              formik.touched[item.field] &&
              formik.values[item.field] &&
              formik.values[item.field].replace(/<[^>]+>/g, "").trim().length <
              Number(item.min_length) && (
                <p className="description-warning">
                  <i className="fas fa-exclamation-triangle"></i>
                  The recommended {item.headerName.toLowerCase()} length is at least {item.min_length} characters.
                </p>
              )}

            <Bform.Control.Feedback
              type="invalid"
              style={
                formik.errors[item.field] && formik.touched[item.field]
                  ? {
                      display: "block",
                    }
                  : {}
              }
            >
              {formik.errors[item.field] && formik.touched[item.field] ? (
                <div class="error">{formik.errors[item.field]}</div>
              ) : null}
            </Bform.Control.Feedback>
          </div>
        </Col>
      );
    }
    if (item.attribute_type === "radio") {
      return (
        <Col md={12} className="mb-3">
          <div className="inputbox-group form_checkbox_validation">
            {item.options?.map((it, index) => {
              return (
                <>
                  <input
                    type={item.attribute_type}
                    ref={(el) => (clearform = el)}
                    placeholder={`${item.headerName}`}
                    name={item.field}
                    onChange={formik.handleChange}
                    value={formik.values[item.field]}
                    className={`input-cls ${item.is_required && "required"}`}
                    autocomplete={"off"}
                    onBlur={(evt) => formik.setFieldTouched(item.field, true)}
                  />{" "}
                  <label>{commonData.firstUpper(it.option_name)}</label>
                </>
              );
            })}
            <Bform.Control.Feedback
              type="invalid"
              style={
                formik.errors[item.field] && formik.touched[item.field]
                  ? {
                      display: "block",
                    }
                  : {}
              }
            >
              {formik.errors[item.field] && formik.touched[item.field] ? (
                <div class="error">{formik.errors[item.field]}</div>
              ) : null}
            </Bform.Control.Feedback>
          </div>
        </Col>
      );
    }
    if (item.attribute_type === "tel") {
      return (
        <Col md={12} className="mb-3">
          <div className="inputbox-group">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >{`${commonData.firstUpper(item.headerName)}`}</label>
            <input
              type={item.attribute_type}
              ref={(el) => (clearform = el)}
              placeholder={`${item.headerName}`}
              name={item.field}
              onChange={formik.handleChange}
              value={formik.values[item.field]}
              className={`input-cls ${item.is_required && "required"}`}
              autocomplete={"off"}
              onBlur={(evt) => formik.setFieldTouched(item.field, true)}
            />
            <Bform.Control.Feedback
              type="invalid"
              style={
                formik.errors[item.field] && formik.touched[item.field]
                  ? {
                      display: "block",
                    }
                  : {}
              }
            >
              {formik.errors[item.field] && formik.touched[item.field] ? (
                <div class="error">{formik.errors[item.field]}</div>
              ) : null}
            </Bform.Control.Feedback>
          </div>
        </Col>
      );
    }
    if (item.attribute_type === "number") {
      return (
        <Col md={12} className="mb-3">
          <div className="inputbox-group">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >{`${commonData.firstUpper(item.headerName)}`}</label>
            <input
              type={item.attribute_type}
              ref={(el) => (clearform = el)}
              placeholder={`${item.headerName}`}
              name={item.field}
              min={0}
              onChange={formik.handleChange}
              value={formik.values[item.field]}
              className={`input-cls ${item.is_required && "required"}`}
              autocomplete={"off"}
              onBlur={() => formik.setFieldTouched(item.field, true)}
            />
            <Bform.Control.Feedback
              type="invalid"
              style={
                formik.errors[item.field] && formik.touched[item.field]
                  ? {
                      display: "block",
                    }
                  : {}
              }
            >
              {formik.errors[item.field] && formik.touched[item.field] ? (
                <div class="error">{formik.errors[item.field]}</div>
              ) : null}
            </Bform.Control.Feedback>
          </div>
        </Col>
      );
    }
    if (item.attribute_type === "date") {
      return (
        <Col md={12} className="mb-3">
          <div className="inputbox-group date">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >{`${commonData.firstUpper(item.headerName)}`}</label>
            <ReactDatePicker
              className="rasta-stripes"
              dateFormat="dd-MM-yyyy"
              selected={
                formik.values[item.field]
                  ? new Date(formik.values[item.field])
                  : null
              }
              placeholderText="dd/mm/yyyy"
              onChange={(evt) => {
                reactDatePickerHandler(evt, formik, item.field);
              }}
            />
            <Bform.Control.Feedback
              type="invalid"
              style={
                formik.errors[item.field] && formik.touched[item.field]
                  ? {
                      display: "block",
                    }
                  : {}
              }
            >
              {formik.errors[item.field] && formik.touched[item.field] ? (
                <div class="error">{formik.errors[item.field]}</div>
              ) : null}
            </Bform.Control.Feedback>
          </div>
        </Col>
      );
    }
    if (item.attribute_type === "start_date") {
      const currentDate = new Date();
      const pastDate = formik.values[item.field]
        ? new Date(formik.values[item.field])
        : currentDate.setDate(currentDate.getDate() - 30);
      return (
        <Col md={12} className="mb-3">
          <div className="inputbox-group date">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >{`${commonData.firstUpper(item.headerName)}`}</label>

            <ReactDatePicker
              className="rasta-stripes"
              dateFormat="dd-MM-yyyy"
              selected={
                formik.values[item.field]
                  ? new Date(formik.values[item.field])
                  : null
              }
              minDate={pastDate}
              placeholderText="dd/mm/yyyy"
              onChange={(evt) =>
                this.reactDatePickerHandler(evt, formik, item.field)
              }
            />

            <Bform.Control.Feedback
              type="invalid"
              style={
                formik.errors[item.field] && formik.touched[item.field]
                  ? {
                      display: "block",
                    }
                  : {}
              }
            >
              {formik.errors[item.field] && formik.touched[item.field] ? (
                <div class="error">{formik.errors[item.field]}</div>
              ) : null}
            </Bform.Control.Feedback>
          </div>
        </Col>
      );
    }
    if (item.attribute_type === "end_date") {
      return (
        <Col md={12} className="mb-3">
          <div className="inputbox-group date">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >{`${commonData.firstUpper(item.headerName)}`}</label>

            <ReactDatePicker
              className="rasta-stripes"
              dateFormat="dd-MM-yyyy"
              selected={
                formik.values[item.field]
                  ? new Date(formik.values[item.field])
                  : null
              }
              minDate={
                formik.values["start_date"]
                  ? new Date(formik.values["start_date"])
                  : new Date()
              }
              placeholderText="dd/mm/yyyy"
              onChange={(evt) =>
                reactDatePickerHandler(evt, formik, item.field)
              }
            />

            <Bform.Control.Feedback
              type="invalid"
              style={
                formik.errors[item.field] && formik.touched[item.field]
                  ? {
                      display: "block",
                    }
                  : {}
              }
            >
              {formik.errors[item.field] && formik.touched[item.field] ? (
                <div class="error">{formik.errors[item.field]}</div>
              ) : null}
            </Bform.Control.Feedback>
          </div>
        </Col>
      );
    }
    if (item.attribute_type === "go_live_date") {
      return (
        <Col md={12} className="mb-3">
          <div className="inputbox-group date">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >{`${commonData.firstUpper(item.headerName)}`}</label>

            <ReactDatePicker
              className="rasta-stripes"
              dateFormat="dd-MM-yyyy"
              selected={formik.values[item.field]}
              minDate={
                formik.values["end_date"] ||
                new Date().setDate(new Date().getDate())
              }
              placeholderText="dd/mm/yyyy"
              onChange={(evt) =>
                reactDatePickerHandler(evt, formik, item.field)
              }
            />

            <Bform.Control.Feedback
              type="invalid"
              style={
                formik.errors[item.field] && formik.touched[item.field]
                  ? {
                      display: "block",
                    }
                  : {}
              }
            >
              {formik.errors[item.field] && formik.touched[item.field] ? (
                <div class="error">{formik.errors[item.field]}</div>
              ) : null}
            </Bform.Control.Feedback>
          </div>
        </Col>
      );
    }
    if (item.attribute_type === "board") {
      return (
        <Col md={12}>
          <div className="inputbox-group">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >
              {commonData.firstUpper(item.headerName)}
            </label>
            <AsyncSelect
              cacheOptions
              defaultOptions
              loadOptions={(evt) =>
                this.loadAddress(item.api_url, evt, "child_board")
              }
              onChange={(value) => {
                formik.setFieldValue(item.field, value.value);
              }}
              onBlur={() => formik.setFieldTouched(item.field, true)}
            />
            <Bform.Control.Feedback
              type="invalid"
              style={
                formik.errors[item.field] && formik.touched[item.field]
                  ? {
                      display: "block",
                    }
                  : {}
              }
            >
              {formik.errors[item.field] && formik.touched[item.field] ? (
                <div class="error">{formik.errors[item.field]}</div>
              ) : null}
            </Bform.Control.Feedback>
          </div>
        </Col>
      );
    }
    if (item.attribute_type === "api") {
      return (
        <Col md={12} className="mb-3">
          <div className="inputbox-group">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >{`${commonData.firstUpper(item.headerName)}`}</label>
            <>
              <AsyncSelect
                placeholder={item.headerName}
                isMulti={item.is_multiple}
                cacheOptions
                ref={(el) => (clearFormSelect[index] = el)}
                value={this.state.apiOptions.find(
                  (ite) => ite.value == formik.values[item.field]
                )}
                defaultOptions
                // isClearable={true}
                loadOptions={(evt) => this.fetchData(item.api_url, evt)}
                onBlur={() => formik.setFieldTouched(item.field, true)}
                maxMenuHeight={175}
                onChange={(value) => {
                  formik.setFieldValue(
                    item.field,
                    !value
                      ? ""
                      : Array.isArray(value)
                      ? value.map((item) => item.value)
                      : value.value
                  );
                }}
              />
            </>

            <Bform.Control.Feedback
              type="invalid"
              style={
                formik.errors[item.field] && formik.touched[item.field]
                  ? {
                      display: "block",
                    }
                  : {}
              }
            >
              {formik.errors[item.field] && formik.touched[item.field] ? (
                <div class="error">{formik.errors[item.field]}</div>
              ) : null}
            </Bform.Control.Feedback>
          </div>
        </Col>
      );
    }
    if (item.attribute_type === "project") {
      return (
        <Col md={12} className="mb-3">
          <div className="inputbox-group">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >{`${commonData.firstUpper(item.headerName)}`}</label>
            <>
              <AsyncSelect
                placeholder={item.headerName}
                isMulti={true}
                ref={(el) => (clearFormSelect[index] = el)}
                cacheOptions
                defaultOptions
                loadOptions={(evt) => this.loadAddress(item.api_url, evt, "er")}
                maxMenuHeight={175}
                onChange={(value) => {
                  formik.setFieldValue(
                    item.field,
                    Array.isArray(value)
                      ? value.map((item) => item.value)
                      : value.value
                  );
                }}
                onBlur={() => formik.setFieldTouched(item.field, true)}
              />
            </>

            <Bform.Control.Feedback
              type="invalid"
              style={
                formik.errors[item.field] && formik.touched[item.field]
                  ? {
                      display: "block",
                    }
                  : {}
              }
            >
              {formik.errors[item.field] && formik.touched[item.field] ? (
                <div class="error">{formik.errors[item.field]}</div>
              ) : null}
            </Bform.Control.Feedback>
          </div>
        </Col>
      );
    }
    if (item.attribute_type === "select") {
      const options = item.options.map((item) => ({
        ...item,
        label: item.option_name,
        value: item._id,
      }));
      return (
        <Col md={12} className="mb-3">
          <div className="inputbox-group">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >{`${commonData.firstUpper(item.headerName)}`}</label>
            <Field
              placeholder={item.headerName}
              isMulti={item.is_multiple}
              options={options}
              key={index}
              refs={(el) => (clearFormSelect[index] = el)}
              onBlur={() => formik.setFieldTouched(item.field, true)}
              maxMenuHeight={175}
              name={item.field}
              component={ReactCustomSelect}
              formik={formik}
            />
          </div>
        </Col>
      );
    }
    if (item.attribute_type === "priority") {
      const options = item.options.map((item) => ({
        ...item,
        label: item.option_name,
        value: item._id,
      }));
      let value;

      if (
        item.hasOwnProperty("defaultvalue") &&
        !formik.values[item.field] &&
        !state.editId
      ) {
        value = options.filter((it) => it.value == item.defaultvalue);
        defaultCheck(item.field, value[0].value);
        setTimeout(() => {
          formik.setFieldValue(item.field, value[0].value);
        });
      } else {
        if (state.findUUID) {
          if (
            groupBy == "status" ||
            groupBy == "priority"
          ) {
            value = options.filter((it) => it.value == state.findUUID);
            defaultCheck(item.field, state.findUUID);
          } else {
            value = options.filter(
              (it) => it.value == formik.values[item.field]
            );
            defaultCheck(item.field, formik.values[item.field]);
          }
        } else {
          value = options.filter((it) => it.value == formik.values[item.field]);
          defaultCheck(item.field, formik.values[item.field]);
        }
      }
      return (
        <Col md={12} className="mb-3">
          <div className="inputbox-group">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >
              {`${commonData.firstUpper(item.headerName)}`}
            </label>
            <ReactSelect
              placeholder={item.headerName}
              options={options}
              value={value}
              key={index}
              onBlur={() => formik.setFieldTouched(item.field, true)}
              isMulti={item.is_multiple}
              maxMenuHeight={175}
              onChange={(evt) => {
                setState((state) => {
                  return {
                    ...state,
                    findUUID: evt.value,
                  };
                });
                formik.setFieldValue(
                  item.field,
                  item.is_multiple
                    ? options.map((item) => item.value)
                    : !evt
                    ? ""
                    : evt.value
                );
              }}
            />
          </div>
        </Col>
      );
    }
    if (item.attribute_type === "category") {
      const options = item.options;
      const newoptions = options.map((item) => ({
        label: item.name,
        value: item._id,
      }));
      const values = newoptions.filter(
        (it) => it.value === formik.values[item.field]
      );
      return (
        <Col md={12} className="mb-3">
          <div className="inputbox-group">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >{`${commonData.firstUpper(item.headerName)}`}</label>
            <ReactSelect
              // isMulti={item.is_multiple}
              options={newoptions || []}
              maxMenuHeight={175}
              ref={(el) => (clearFormSelect[index] = el)}
              value={values}
              name="label"
              placeholder={commonData.firstUpper(item.headerName)}
              onChange={(value) =>
                formik.setFieldValue(item.field, value.value)
              }
            />
          </div>
          <Bform.Control.Feedback
            type="invalid"
            style={
              formik.errors[item.field] && formik.touched[item.field]
                ? {
                    display: "block",
                  }
                : {}
            }
          >
            {formik.errors[item.field] && formik.touched[item.field] ? (
              <div class="error">{formik.errors[item.field]}</div>
            ) : null}
          </Bform.Control.Feedback>
        </Col>
      );
    }
    if (item.attribute_type === "reporter") {
      const { options } = item;
      // const userDetails = commondata.IsJsonString(
      //   this.state.boarddata.user_details
      // )
      //   ? JSON.parse(this.state.boarddata.user_details)
      //   : "";

      //check todo

      const { SingleValue, Option } = components;

      let value;
      if (
        item.hasOwnProperty("defaultvalue") &&
        item.defaultvalue &&
        !formik.values[item.field]
      ) {
        value = state.activeUsers.filter(
          (it) => it.value == commonData.getCommonData().user_uuid
        );
        defaultCheck(item.field, commonData.getCommonData().user_uuid);
        setTimeout(() => {
          formik.setFieldValue(item.field, value?.[0]?.value);
        });
      } else if (formik.values[item.field]) {
        value = state.activeUsers.filter(
          (it) => it.value == formik.values[item.field]
        );
        defaultCheck(item.field, value?.[0]?.value);
      } else {
        value = state.activeUsers.filter(
          (it) => it.value == commonData.commonData().userId
        );
        defaultCheck(item.field, value?.[0]?.value);
      }

      return (
        <Col md={12} className="mb-3">
          <div className="inputbox-group">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >{`Assigned By`}</label>
            <AsyncSelect
              cacheOptions
              defaultOptions
              maxMenuHeight={175}
              loadOptions={(evt) =>
                getPeoplesCall(evt, item.api_url, state, setState)
              }
              menuPlacement="auto"
              isMulti={item.is_multiple}
              components={{ Option: CustomOption }}
              name="label"
              // isClearable={true}
              value={value}
              placeholder={commonData.firstUpper(item.headerName)}
              onChange={(value) =>
                formik.setFieldValue(item.field, !value ? "" : value.value)
              }
              onBlur={() => formik.setFieldTouched(item.field, true)}
            />
          </div>
          <Bform.Control.Feedback
            type="invalid"
            style={
              formik.errors[item.field] && formik.touched[item.field]
                ? {
                    display: "block",
                  }
                : {}
            }
          >
            {formik.errors[item.field] && formik.touched[item.field] ? (
              <div class="error">{formik.errors[item.field]}</div>
            ) : null}
          </Bform.Control.Feedback>
        </Col>
      );
    }
    if (item.attribute_type === "assign_to") {
      const { options } = item;

      let value;
      if (
        item.hasOwnProperty("defaultvalue") &&
        item.defaultvalue &&
        !formik.values[item.field] &&
        !state.user_uuid
      ) {
        value = state.activeUsers.filter(
          (it) => it.value == commonData.getCommonData().user_uuid
        );
        setTimeout(() => {
          formik.setFieldValue(item.field, value?.[0]?.value);
        });
      } else {
        if (state.user_uuid) {
          if (
            groupBy == "status" ||
            groupBy == "priority"
          ) {
            if (formik.values[item.field]) {
              value = state.activeUsers.filter(
                (it) => it.value == formik.values[item.field] || ""
              );
            } else {
              value = state.activeUsers.filter(
                (it) => it.value == commonData.getCommonData().user_uuid || ""
              );
              setTimeout(() => {
                formik.setFieldValue(item.field, value?.[0]?.value);
              });
            }

            // defaultCheck(item.field, state.user_uuid, formik);
          } else if (state.user_uuid && !formik.values[item.field]) {
            value = state.activeUsers.filter(
              (it) => it.value == state.user_uuid
            );

            setTimeout(() => {
              formik.setFieldValue(item.field, value?.[0]?.value);
            });

            defaultCheck(item.field, value?.[0]?.value);
          } else if (formik.values[item.field]) {
            value = state.activeUsers.filter(
              (it) => it.value == formik.values[item.field]
            );

            defaultCheck(item.field, value?.[0]?.value);
          }

          defaultCheck(item.field, value?.[0]?.value, formik);
        } else {
          value = state.activeUsers.filter(
            (it) => it.value == formik.values[item.field]
          );

          defaultCheck(item.field, formik.values[item.field]);
        }
      }

      return (
        <Col md={12} className="mb-3">
          <div className="inputbox-group">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >{`${commonData.firstUpper(item.headerName)}`}</label>
            <AsyncSelect
              cacheOptions
              defaultOptions
              maxMenuHeight={175}
              loadOptions={(evt) =>
                getPeoplesCall(evt, item.api_url, state, setState)
              }
              menuPlacement="auto"
              isMulti={item.is_multiple}
              components={{ Option: CustomOption }}
              name="label"
              // isClearable={true}
              value={value || ""}
              placeholder={commonData.firstUpper(item.headerName)}
              onChange={(value) =>
                formik.setFieldValue(item.field, !value ? "" : value.value)
              }
              onBlur={() => formik.setFieldTouched(item.field, true)}
            />
          </div>
          <Bform.Control.Feedback
            type="invalid"
            style={
              formik.errors[item.field] && formik.touched[item.field]
                ? {
                    display: "block",
                  }
                : {}
            }
          >
            {formik.errors[item.field] && formik.touched[item.field] ? (
              <div class="error">{formik.errors[item.field]}</div>
            ) : null}
          </Bform.Control.Feedback>
        </Col>
      );
    }
    if (item.attribute_type === "status") {
      const newoptions =
        item?.options &&
        item.options.map((item) => ({
          label: item.name,
          value: item._id,
        }));
      const statusVal = newoptions.filter(
        (it) => it.value === formik.values[item.field]
      );
      return (
        <Col md={12} className="mb-3">
          <div className="inputbox-group">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >{`${commonData.firstUpper(item.headerName)}`}</label>
            <ReactSelect
              // isMulti={item.is_multiple}
              options={newoptions || []}
              maxMenuHeight={175}
              ref={(el) => (clearFormSelect[index] = el)}
              value={statusVal}
              name="label"
              placeholder={commonData.firstUpper(item.headerName)}
              onChange={(value) =>
                formik.setFieldValue(item.field, value.value)
              }
            />
          </div>
        </Col>
      );
    }
    if (item.attribute_type === "reporter") {
      const { SingleValue, Option } = components;

      const IconOption = (props) => {
        const getimage = props.options.find(
          (item) => item.value === props.value
        ).profile;
        return (
          <Option {...props}>
            <img
              style={{ width: "20px" }}
              src={`${
                getimage ||
                "data:image/png;base64,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"
              }`}
            />{" "}
            &nbsp;
            {props.data.label}
          </Option>
        );
      };
      let newoptions = [];

      if (Array.isArray(item.options)) {
        newoptions = item?.options?.map((item) => {
          return {
            ...item,
            label: item.name,
            value: item._id,
            profile: item.profile_image,
          };
        });
      } else {
        for (let ip in item.options) {
          newoptions.push({
            label: item.options[ip].name,
            value: item.options[ip].user_uuid,
            profile: item.options[ip].profile_image,
          });
        }
      }

      let value;
      if (
        item.hasOwnProperty("defaultvalue") &&
        item.defaultvalue &&
        !formik.values[item.field]
      ) {
        value = newoptions.filter(
          (it) => it.value == commonData.getCommonData().user_uuid
        );
        defaultCheck(item.field, commonData.getCommonData().user_uuid);
        formik.setFieldValue(item.field, commonData.getCommonData().user_uuid);
      } else {
        value = newoptions.filter(
          (it) => it.value == formik.values[item.field]
        );
        defaultCheck(item.field, formik.values[item.field]);
      }

      return (
        <Col md={12} className="mb-3">
          <div className="inputbox-group">
            <label
              className={
                "col-12 " + (item.is_required ? "form-label _required" : "")
              }
            >{`${commonData.firstUpper(item.headerName)}`}</label>
            <ReactSelect
              isMulti={item.is_multiple}
              options={newoptions || []}
              maxMenuHeight={175}
              name="label"
              value={value}
              components={{
                Option: IconOption,
              }}
              placeholder={commonData.firstUpper(item.headerName)}
              onChange={(value) =>
                formik.setFieldValue(item.field, value.value)
              }
              onBlur={() => formik.setFieldTouched(item.field, true)}
            />
          </div>
        </Col>
      );
    }
    if (
      [
        "textarea",
        "tel",
        "checkbox",
        "radio",
        "select",
        "attachment",
        "text",
        "number",
        "email",
        "date",
        "api",
        "er",
      ].includes(item.attribute_type) === false
    ) {
      if (item.attribute_type === "customer") {
        return (
          <Col md={12} className="mb-3">
            <div className="inputbox-group">
              <label
                className={
                  "col-12 " + (item.is_required ? "form-label _required" : "")
                }
              >{`${commonData.firstUpper(item.headerName)}`}</label>
              <>
                <input
                  type={item.attribute_type}
                  ref={(el) => (clearform = el)}
                  placeholder={`${item.headerName}`}
                  name={item.field}
                  onChange={formik.handleChange}
                  value={formik.values[item.field]}
                  className={`input-cls ${item.is_required && "required"}`}
                  autoComplete={"off"}
                  onBlur={() => formik.setFieldTouched(item.field, true)}
                />
              </>
              <Bform.Control.Feedback
                type="invalid"
                style={
                  formik.errors[item.field] && formik.touched[item.field]
                    ? {
                        display: "block",
                      }
                    : {}
                }
              >
                {formik.errors[item.field] && formik.touched[item.field] ? (
                  <div class="error">{formik.errors[item.field]}</div>
                ) : null}
              </Bform.Control.Feedback>
            </div>
          </Col>
        );
      }
    }

    let newoptions = [];
    for (let ip in item.options) {
      newoptions.push({
        label: `${item.options[ip].name}`,
        value: item.options[ip].user_uuid || item.ip,
      });
    }
    const values = newoptions.filter(
      (ite) => ite.value === formik.values[item.field]
    );
    return (
      <Col md={12} className="mb-3">
        <div className="inputbox-group">
          <label
            className={
              "col-12 " + (item.is_required ? "form-label _required" : "")
            }
          >{`${commonData.firstUpper(item.headerName)}`}</label>
          <ReactSelect
            options={newoptions || []}
            isMulti={item.is_multiple}
            name="label"
            maxMenuHeight={175}
            placeholder={commonData.firstUpper(item.headerName)}
            ref={(el) => (clearFormSelect[index] = el)}
            value={values}
            onChange={(value) => {
              formik.setFieldValue(item.field, value.value);
            }}
            onBlur={() => formik.setFieldTouched(item.field, true)}
          />
          <Bform.Control.Feedback
            type="invalid"
            style={
              formik.errors[item.field] && formik.touched[item.field]
                ? {
                    display: "block",
                    createLayoutDropabble,
                  }
                : {}
            }
          >
            {formik.errors[item.field] && formik.touched[item.field] ? (
              <div class="error">{formik.errors[item.field]}</div>
            ) : null}
          </Bform.Control.Feedback>
        </div>
      </Col>
    );
  };

  //filter view select dropdown

  const getFilterViewSelect = () => {
    try {
      const newFomratView = [...state.filterView];

      let options = newFomratView.map((ite) => ({
        label: ite.filter_name,
        value: ite.filter_id,
      }));

      return (
        <>
          <ReactSelect
            classNamePrefix="kanbanviewsave"
            styles={customStyles}
            options={options}
            onChange={applyFilterHandler}
          />
        </>
      );
    } catch (err) {
      console.log(err);
    }
  };
  const dynamicFilterChangeHandler = (obj) => {
    const groupBy = getGroupForKanban(params.attribute_set_key) || "priority"
    let keys = Object.keys(obj)[0];
    let values = Object.values(obj)[0];
    let {group_by, ...objdata} = obj;

    let nvalues;

    if (Array.isArray(values)) {
      nvalues = values.map((kk) => kk.value);
    } else {
      nvalues = values?.value;
    }
    if (state.filters.hasOwnProperty("columns")) {
      setState((state) => {
        return {
          ...state,
          filters: {
            columns: state.filters.columns,
            ...objdata,
          },
        };
      });
    } else {
      setState((state) => {
        return {
          ...state,
          filters: {
            ...objdata,
          },
        };
      });
    }
    let newdata = {
      ...objdata,
    };

    let { filter_id, ...rest } = newdata;
    setToLocalStorage({
      ...objdata,
      group_by: groupBy,
    });

    //when filter is manupulated it shoudl reset the selected filter
    // get the previous added selectedfilter

    const selectedfilter = localStorage.getItem("selected_filter");

    if (selectedfilter && commonData.IsJsonString(selectedfilter)) {
      let parseselectedfilter = JSON.parse(selectedfilter);
      if (parseselectedfilter.hasOwnProperty(params.attribute_set_key)) {
        parseselectedfilter = {
          ...parseselectedfilter,
          [params.attribute_set_key]: "",
        };
      }

      localStorage.setItem(
        "selected_filter",
        JSON.stringify(parseselectedfilter)
      );
    }
    if (state.filters.hasOwnProperty("columns")) {
      const { columns, ...rest } = state.filters;
      callTheApiDefaut(
        {
          ...objdata,
          group_by: groupBy,
        },
        null,
        columns
      );
    } else {
      callTheApiDefaut({
        ...objdata,
        group_by: groupBy,
      });
    }
  };
  // assign to chnages

  const assignToChangeHandler = (evt) => {
    const groupBy = getGroupForKanban(params.attribute_set_key) || "priority"
    setState((state) => {
      return {
        ...state,
        filters: {
          ...state.filters,
          assign_to: evt,
        },
      };
    });
    resetFilterKanaban();
    setToLocalStorage({
      ...state.filters,
      assign_to: evt,
      group_by: groupBy || "assign_to",
    });
    callTheApiDefaut({
      ...state.filters,
      assign_to: evt,
      group_by: groupBy || "assign_to",
    });
  };
  //format encode text to decode it
  const decodeHtmlEntities = (input) => {
    var doc = new DOMParser().parseFromString(input, "text/html");
    return doc.documentElement.textContent;
  };

  const callApiHandler = async () => {
    const fetchresp = await fetch(
      "https://tattleapi-dev.muvistaging.com/get-releases?month=6&year=2024"
    );
    const rdata = await fetchresp.json();

    return rdata.map((item) => ({ label: item.value, value: item.id }));
  };

  const submitAssigntoReleaseHandler = async () => {
    let request = {
      app_token: commonData.getCommonData().app_token,
      attribute_set_key: params.attribute_set_key,
      customer_tattle_uuid: [...state.assignToReleaseData],
      release: releaseassignvalue,
      user_uuid: commonData.getCommonData().user_uuid,
    };

    const rdata = await fetch(
      `${commonData.getCommonData().apiUrl}/tattle/update-release`,
      {
        method: "POST",
        body: JSON.stringify(request),
      }
    );

    const response = await rdata.json();

    if (response.code == 200) {
      setState((state) => {
        return {
          ...state,
          assignToReleaseData: [],
        };
      });
      setAssignToRelease(false);
      releaseFromBacklog();
    }
  };

  const removeFromBacklogHandler = async () => {
    setState((state) => {
      return {
        ...state,
        isReleaseFromBack: true,
      };
    });
    let request = {
      app_token: commonData.getCommonData().app_token,
      attribute_set_key: params.attribute_set_key,
      customer_tattle_uuid: [...state.assignToReleaseData],
      release: "",
      user_uuid: commonData.getCommonData().user_uuid,
    };
    const rdata = await fetch(
      `${commonData.getCommonData().apiUrl}/tattle/update-release`,
      {
        method: "POST",
        body: JSON.stringify(request),
      }
    );

    const response = await rdata.json();

    if (response.code == 200) {
      setState((state) => {
        return {
          ...state,
          assignToReleaseData: [],
          isReleaseFromBack: false,
        };
      });
      setAssignToRelease(false);
      releaseFromBacklog();
    }
  };

  const optionFieldValue = (columns, field, val) => {
    if (field === "created_date" && state.boarddata.attribute_set_type === 4) {
      let newdate;
      let date = !isNaN(Date.parse(val?.created_date))
        ? moment(val?.created_date).format(
            process.env.REACT_APP_DATE_FORMAT_TODO
          )
        : "";
      if (val?.end_date || val?.eta) {
        newdate = ` - ${
          !isNaN(Date.parse(val?.end_date || val?.eta))
            ? moment(val?.end_date || val?.eta).format(
                process.env.REACT_APP_DATE_FORMAT_TODO
              )
            : ""
        }`;
      }

      return (
        <div style={{ cursor: "pointer" }} className="date-rest">
          <OverlayTrigger
            key={"created_date"}
            placement={"auto"}
            overlay={
              <Tooltip id={`created_date`}>
                <strong>{`Created On`}</strong>
              </Tooltip>
            }
          >
            <span className="">{date}</span>
          </OverlayTrigger>{" "}
          <OverlayTrigger
            key={"created_date"}
            placement={"auto"}
            overlay={
              <Tooltip id={`eta`}>
                <strong>{`${val?.end_date || val?.eta ? "ETA" : ""}`}</strong>
              </Tooltip>
            }
          >
            <span className="">{newdate}</span>
          </OverlayTrigger>
        </div>
      );
    }
    if (field === "priority") {
      const column = columns.find((ite) => ite.field === field);

      const { options } = column || {};

      const getValue = options?.find((ite) => ite._id == val);

      if (getValue?.option_name == "Medium") {
        return (
          <OverlayTrigger
            key={"medium"}
            placement={"right"}
            overlay={
              <Tooltip id={`medium`}>
                <strong>Medium</strong>
              </Tooltip>
            }
          >
            <span>
              <Medium />
            </span>
          </OverlayTrigger>
        );
      }
      if (getValue?.option_name == "Low") {
        return (
          <OverlayTrigger
            key={"low"}
            placement={"right"}
            overlay={
              <Tooltip id={`low`}>
                <strong>Low</strong>
              </Tooltip>
            }
          >
            <span>
              <Lowest />
            </span>
          </OverlayTrigger>
        );
      }
      if (getValue?.option_name == "High") {
        return (
          <OverlayTrigger
            key={"high"}
            placement={"right"}
            overlay={
              <Tooltip id={`high`}>
                <strong>High</strong>
              </Tooltip>
            }
          >
            <span>
              <High />
            </span>
          </OverlayTrigger>
        );
      }
      if (getValue?.option_name == "Critical") {
        return (
          <OverlayTrigger
            key={"low"}
            placement={"right"}
            overlay={
              <Tooltip id={`critical`}>
                <strong>Critical</strong>
              </Tooltip>
            }
          >
            <span>
              <Critical />
            </span>
          </OverlayTrigger>
        );
      }
      if (getValue?.option_name == "Very High") {
        return (
          <OverlayTrigger
            key={"veryhigh"}
            placement={"right"}
            overlay={
              <Tooltip id={`veryhigh`}>
                <strong>Very High</strong>
              </Tooltip>
            }
          >
            <span>
              <Highest />
            </span>
          </OverlayTrigger>
        );
      }
    }
    if (field === "status") {
      const column = columns?.find((ite) => ite.attribute_type === field);
      const { options } = column || {};
      const getValue = options?.find((ite) => ite._id == val);

      return (
        <p className="content">
          <span
            className={`status-text status_label_details customKanban`}
            style={{
              backgroundColor: commonData.hexToRgba(getValue?.color, 0.1)
                .backgroundColor,
              color: "#" + commonData.hexToRgba(getValue?.color, 0.1).color,
              border: `1px solid ${
                commonData.hexToRgba(getValue?.color, 0.1).borderColor
              }`,
            }}
          >
            {getValue?.name}
          </span>
        </p>
      );
    }

    if (field === "assign_to") {
      if (
        columns.hasOwnProperty(val) &&
        (columns[val]?.profile_image || columns[val]?.profile_image)
      ) {
        return (
          <>
            {" "}
            <img
              src={columns[val]?.profile_image || columns[val]?.profile_pic}
              alt="user-img"
              class="avatar-xs rounded-circle me-1 insideImage"
            />
          </>
        );
      }
    }
    if (field === "monitoring") {
      return (
        <div className="avatar-group-cc">
          {val.map(
            (it) =>
              state.users.hasOwnProperty(it) && (
                <a
                  href="javascript: void(0);"
                  class="avatar-group-item"
                  data-bs-toggle="tooltip"
                  data-bs-trigger="hover"
                  data-bs-placement="top"
                  aria-label="Brent Gonzalez"
                  data-bs-original-title="Brent Gonzalez"
                >
                  <OverlayTrigger
                    key={state.users[it].user_uuid}
                    placement="top"
                    overlay={
                      <Tooltip id={state.users[it].user_uuid}>
                        <strong>{state.users[it].name}</strong>
                      </Tooltip>
                    }
                  >
                    <div class="">
                      <img
                        src={`${state.users[it].profile_image}`}
                        alt=""
                        class="rounded-circle img-fluid"
                      />
                    </div>
                  </OverlayTrigger>
                </a>
              )
          )}
        </div>
      );
    }
    if (field === "category") {
      const column = columns.find((ite) => ite.attribute_type === field);
      const { options } = column;
      const getValue = options.find((ite) => ite._id == val);
      return <span class="badge bg-secondary"> {getValue?.name}</span>;
    }
  };

  const completeTodoHandler = async (data, ev) => {
    const groupBy = getGroupForKanban(params.attribute_set_key) || "priority"
    const { pin } = data;
    ev.stopPropagation();
    let newdta = groupBy;
    const { customer_tattle_uuid } = data;
    const { checked } = ev.target;
    const newvalues = Object.assign(
      { customer_tattle_uuid: customer_tattle_uuid },
      { ...data },
      {
        attribute_set_key: params.attribute_set_key,
        app_token: commonData.commonData().appToken,
        user_uuid: commonData.commonData().userId,
        completed: checked.toString(),
      }
    );

    const formdata = new FormData();
    for (let key in newvalues) {
      formdata.append(key, newvalues[key]);
    }
    let getdata = state.cardData[data[newdta]][pin ? "pinned" : "unpinned"];
    let newdata = getdata.map((item) => {
      if (item.customer_tattle_uuid == customer_tattle_uuid) {
        return { ...item, completed: checked.toString() };
      }
      return item;
    });

    setState((state) => {
      return {
        ...state,
        cardData: {
          ...state.cardData,
          [data[newdta]]: {
            ...{ pinned: state.cardData[data[newdta]]["pinned"] },
            ...{ unpinned: state.cardData[data[newdta]]["unpinned"] },
            [pin ? "pinned" : "unpinned"]: newdata,
          },
        },
      };
    });

    const response = await fetch(`${state.api}tattle/update`, {
      method: "POST",
      body: JSON.stringify({
        attribute_set_key: params.attribute_set_key,
        app_token: commonData.commonData().appToken,
        user_uuid: commonData.commonData().userId,
        completed: checked.toString(),
        customer_tattle_uuid: customer_tattle_uuid,
      }),
    });
    const rdata = await response.json();
    if (rdata.code == 200) {
      setState((state) => {
        return {
          ...state,
          // createBoard: {
          //   ...state.createBoard,
          //   board: true,
          //   message: rdata.message,
          //   title: rdata.status,
          // },
        };
      });

      if (
        state.filters.completed === "false" ||
        state.filters.completed === "true"
      ) {
        setTimeout(() => {
          // Update the state to remove the item from the list
          setState((state) => {
            return {
              ...state,
              cardData: {
                ...state.cardData,
                [data[newdta]]: {
                  ...{ pinned: state.cardData[data[newdta]]["pinned"] },
                  ...{ unpinned: state.cardData[data[newdta]]["unpinned"] },
                  [pin ? "pinned" : "unpinned"]: state.cardData[data[newdta]][
                    pin ? "pinned" : "unpinned"
                  ].filter(
                    (item) => item.completed === state.filters?.completed
                  ),
                },
              },
            };
          });
        }, 200);
      }
    }
  };
  const coptTodoLinkHandler = async (e, uuid) => {
    e.stopPropagation();
    let url = `${window.location.origin}/tattle/${params.attribute_set_key}/${uuid}`;
    await navigator.clipboard.writeText(url);

    setState((state) => {
      return {
        ...state,
        copied: true,
      };
    });
  };

  const getReletedTattleIdHandler = (id) => {
    setState((state) => {
      return {
        ...state,
        errorRelation: {
          ...state.errorRelation,
          relationId: "",
        },
        related_tattle_id: id,
      };
    });
  };

  const assigntoRelease = () => {
    setAssignToRelease(!assigntorelease);
  };

  const assignToReleaseInputChange = (evt) => {
    const { checked, value } = evt.target;
    let releaseData = new Set([...state.assignToReleaseData]);

    //check if id is exist if it is exist then

    if (releaseData.has(value)) {
      releaseData.delete(value);
    } else {
      releaseData.add(value);
    }
    setState((sta) => {
      return {
        ...sta,
        assignToReleaseData: Array.from(releaseData),
      };
    });
  };

  const releaseFromBacklog = () => {
    const groupBy = getGroupForKanban(params.attribute_set_key) || "priority"
    const { group_by, ...rest } = state.filters;
    callTheApiDefaut({
      ...rest,
      group_by: state.explicitGroupChange || groupBy,
    });
  };

  const clearTattleIdHandler = () => {
    setState((state) => {
      return {
        ...state,
        related_tattle_id: "",
      };
    });
  };

  //pinned the card

  const pinnedHandler = async (data, e) => {
    const groupBy = getGroupForKanban(params.attribute_set_key) || "priority"
    e.stopPropagation();
    const carddata = { ...state.cardData };
    const ids = data[groupBy];
    let pinneddata =
      data.pin === true ? carddata[ids]?.pinned : carddata[ids].unpinned;

    const customer_uuid = data.customer_tattle_uuid;
    pinneddata = pinneddata.map((item) => {
      if (
        item.customer_tattle_uuid === customer_uuid &&
        item.hasOwnProperty("pin")
      ) {
        return {
          ...item,
          pin: !item.pin,
        };
      } else if (
        item.customer_tattle_uuid === customer_uuid &&
        !item.hasOwnProperty("pin")
      ) {
        return { ...item, pin: true };
      } else {
        return item;
      }
    });

    if (data.pin === true) {
      const index = pinneddata.findIndex(
        (item) => item.customer_tattle_uuid === data.customer_tattle_uuid
      );
      const dataremoved = pinneddata.splice(index, 1);
      carddata[ids].pinned = pinneddata;
      let unppinnedda = carddata[ids].unpinned || [];
      unppinnedda.push(dataremoved[0]);
      carddata[ids].unpinned = unppinnedda;
    } else {
      const index = pinneddata.findIndex(
        (item) => item.customer_tattle_uuid === data.customer_tattle_uuid
      );
      const dataremoved = pinneddata.splice(index, 1);
      carddata[ids].unpinned = pinneddata;
      let unppinnedda = carddata[ids].pinned || [];
      unppinnedda.push(dataremoved[0]);
      carddata[ids].pinned = unppinnedda;
    }

    setState((state) => {
      return {
        ...state,
        cardData: carddata,
      };
    });

    const pinnedRequest = {
      attribute_set_key: params.attribute_set_key,
      app_token: commonData.commonData().appToken,
      user_uuid: commonData.commonData().userId,
      pin: data?.pin ? !data.pin : true,
      customer_tattle_uuid: customer_uuid,
    };
    const response = await fetch(`${state.api}/tattle/update`, {
      method: "POST",
      body: JSON.stringify(pinnedRequest),
    });

    const resdata = await response.json();
  };

  // get form value

  const getFormFieldWithValue = (columns, data) => {
    const groupBy = getGroupForKanban(params.attribute_set_key) || "priority"
    return (
      <div class="card-body p-0 py-2 px-2">
        <div className="main_header_check_title">
          {data?.hasOwnProperty("completed") && (
            <input
              type="checkbox"
              checked={data.completed == "true" ? true : false}
              onClick={completeTodoHandler.bind(this, data)}
              disabled={data.isDisabled}
            />
          )}
          <div class="mainchecktitle">
            <div className="top-title-id">
              {state.boarddata.attribute_set_type !== 4 && (
                <div className="subworflow">
                  <input
                    type="checkbox"
                    name={data?.customer_tattle_uuid}
                    className="form-check-input"
                    checked={state.assignToReleaseData.includes(
                      String(data?.customer_tattle_uuid)
                    )}
                    value={data?.customer_tattle_uuid}
                    onChange={assignToReleaseInputChange}
                    id=""
                  />

                  <a href={`${data?.customer_tattle_uuid}`} target="_blank">
                    {"#"}
                    {data?.customer_tattle_uuid}
                  </a>
                </div>
              )}{" "}
              {state.boarddata.attribute_set_type !== 4 && "-"}
              <OverlayTrigger
                placement="top"
                overlay={
                  <Tooltip id={`tooltip-title-${data?.customer_tattle_uuid || data?._id}`}>
                    {data?.title}
                  </Tooltip>
                }
              >
                <span
                  href="#"
                  data-bs-toggle="modal"
                  data-bs-target="#task-detail-modal"
                  class={`text-body ${
                    data.completed == "true" ? "strikethrough" : ""
                  }`}
                >
                  {data?.title && data.title.length > 50
                    ? data?.title.slice(0, 50) + "..."
                    : data?.title}
                </span>
              </OverlayTrigger>
            </div>
          </div>
        </div>

        {data.hasOwnProperty("created_date") && (
          <div className="foolterkan">
            <div className="statusFlow">
              <div className="created_date">
                {optionFieldValue(state.columns, "created_date", data)}
              </div>
            </div>
          </div>
        )}
        <div className="end_footer">
          
          {data.hasOwnProperty("assign_to") && (
            <div className="assignpeople">
              {groupBy !== "assign_to" &&
                state.filters.hasOwnProperty("assign_to") &&
                state.filters.assign_to.length > 1 && (
                  <div className="assign_image">
                    {optionFieldValue(
                      state.users,
                      "assign_to",
                      data?.assign_to
                    )}
                  </div>
                )}
            </div>
          )}
          {data.hasOwnProperty("priority") &&
            groupBy !== "priority" &&
            optionFieldValue(state.columns, "priority", data?.priority) && (
              <div className="prirotykan">
                {optionFieldValue(state.columns, "priority", data?.priority)}{" "}
              </div>
            )}
          {data.hasOwnProperty("status") && (
            <div className="statusflow">
              {groupBy !== "status" &&
                optionFieldValue(state.columns, "status", data?.status)}
            </div>
          )}
          {/* {data.hasOwnProperty("monitoring") &&
            data.monitoring &&
            Array.isArray(data.monitoring) && (
              <div className="cc_images">
                {optionFieldValue(state.users, "monitoring", data?.monitoring)}
              </div>
            )} */}
          <div className="cta_icons">
            {getPinnedUi(columns, data)}
            <ShowMoreDrop addNotesHandler={addNotesHandler} data={data} />
            <div
              className="notesbtn"
              onClick={addNotesHandler.bind(this, data)}
            >
              <OverlayTrigger
                key={"medium"}
                placement={"top"}
                overlay={
                  <Tooltip id={`medium`}>
                    <strong>Notes</strong>
                  </Tooltip>
                }
              >
                <ul>
                  <li>
                    <Comment />
                  </li>
                </ul>
              </OverlayTrigger>
            </div>
          </div>
        </div>
      </div>
    );
  };

  const getNameByGroupName = (id) => {
    const group_by = getGroupForKanban(params.attribute_set_key) || "priority";
    
    if (groupBy == "assign_to") {
      return (
        <>
          <img
            src={
              state.users?.[id]?.profile_pic || state.users?.[id]?.profile_image
            }
            className="rounded-circle img-fluid header_image"
          />
          {state.users[id]?.name}
        </>
      );
    } else if (groupBy == "category") {
      const categories = state.columns.find(
        (it) => it.attribute_type === groupBy
      );
      if (categories) {
        const { options } = categories;
        let getValue = options.find((getVa) => getVa._id == id);
        return getValue?.name;
      }
    } else if (groupBy == "priority") {
      const getColsPriority =
        state.boarddata.attribute_set_type === 2
          ? state.columns.find((ite) => ite.attribute_type === "select")
          : state.columns.find((ite) => ite.attribute_type === groupBy);

      const { options } = getColsPriority || {};
      const getValue = options?.find((getVa) => getVa._id == id);
      if (getValue?.option_name == "Medium") {
        return (
          <OverlayTrigger
            key={"medium"}
            placement={"right"}
            overlay={
              <Tooltip id={`medium`}>
                <strong>Medium</strong>
              </Tooltip>
            }
          >
            <span>
              <Medium /> {getValue?.option_name}
            </span>
          </OverlayTrigger>
        );
      }
      if (getValue?.option_name == "Very High") {
        return (
          <OverlayTrigger
            key={"veryhigh"}
            placement={"right"}
            overlay={
              <Tooltip id={`veryhigh`}>
                <strong>Very High</strong>
              </Tooltip>
            }
          >
            <span>
              <Highest /> {getValue?.option_name}
            </span>
          </OverlayTrigger>
        );
      }
      if (getValue?.option_name == "Low") {
        return (
          <OverlayTrigger
            key={"low"}
            placement={"right"}
            overlay={
              <Tooltip id={`low`}>
                <strong>Low</strong>
              </Tooltip>
            }
          >
            <span>
              <Lowest /> {getValue?.option_name}
            </span>
          </OverlayTrigger>
        );
      }
      if (getValue?.option_name == "Deferred") {
        return (
          <OverlayTrigger
            key={"low"}
            placement={"right"}
            overlay={
              <Tooltip id={`Deferred`}>
                <strong>Deferred</strong>
              </Tooltip>
            }
          >
            <span>
              <Deferred /> {getValue?.option_name}
            </span>
          </OverlayTrigger>
        );
      }
      if (getValue?.option_name == "High") {
        return (
          <OverlayTrigger
            key={"high"}
            placement={"right"}
            overlay={
              <Tooltip id={`high`}>
                <strong>High</strong>
              </Tooltip>
            }
          >
            <span>
              <High /> {getValue?.option_name}
            </span>
          </OverlayTrigger>
        );
      }
      if (getValue?.option_name == "Critical") {
        return (
          <OverlayTrigger
            key={"low"}
            placement={"right"}
            overlay={
              <Tooltip id={`critical`}>
                <strong>Critical</strong>
              </Tooltip>
            }
          >
            <span>
              <Critical /> {getValue?.option_name}
            </span>
          </OverlayTrigger>
        );
      }
    } else if (groupBy == "status") {
      const getColsPriority = state.columns.find(
        (ite) => ite.attribute_type === groupBy
      );

      if (getColsPriority) {
        const { options } = getColsPriority;
        let getValue = options.find((getVa) => getVa._id == id);

        return (
          <span
            className={`status-text status_label_details`}
            style={{
              backgroundColor: commonData.hexToRgba(getValue?.color, 0.1)
                .backgroundColor,
              color: "#" + commonData.hexToRgba(getValue?.color, 0.1)?.color,
              // border: `1px solid ${
              //   commonData.hexToRgba(getValue.color, 0.1).borderColor
              // }`,
            }}
          >
            <strong>{getValue?.name}</strong>
          </span>
        );
      }
    } else if (groupBy === "category") {
      const getCat = state.columns.find(
        (ite) => ite.attribute_type === groupBy
      );

      if (getCat) {
        const { options } = getCat || {};
      }
    }
  };
  function changePosition(obj, oldIndex, newIndex) {
    const entries = Object.entries(obj);
    const [removed] = entries.splice(oldIndex, 1);
    entries.splice(newIndex, 0, removed);
    // console.log(entries, 454335565654);
    obj = entries.reduce((acc, [key, value]) => {
      acc[key] = value;
      return acc;
    }, {});
    return obj;
  }

  const getColsResiFunc = (cols) => {
    // console.log(cols, 345352344534564);
    // const getIds = cols.map((item) => item[0]);
    // console.log(getIds, 2354354546456456);
  };

  const onDragDropEnds = async (oldi, newi) => {
    const groupBy = getGroupForKanban(params.attribute_set_key) || "priority"
    const newObj = changePosition(state.cardData, oldi, newi);
    setState((state) => {
      return {
        ...state,
        cardData: newObj,
      };
    });
    const getkeys = Object.keys(newObj);
    const getkanbanselectedobj = localStorage.getItem("selected_filter");
    const app_token = commonData.commonData().appToken;
    const user_uuid = commonData.commonData().userId;
    let getid = "";
    const getselectedobjparse = JSON.parse(getkanbanselectedobj);
    getid = getselectedobjparse[state.boarddata.attribute_set_key];
    const sequenceorder = {
      filter_id: getid || "",
      app_token: app_token,
      sequence: getkeys,
      group_by: groupBy,
      user_uuid: user_uuid,
      attribute_set_key: state.boarddata.attribute_set_key,
    };
    const kanbanOrderResponse = await fetch(
      `${state.api}kanban/kanban-column-ordering-sequence`,
      {
        method: "POST",
        body: JSON.stringify(sequenceorder),
      }
    );

    const rdata = await kanbanOrderResponse.json();

    if (rdata.code === 200) {
      const mainDropColumn = document.querySelectorAll(".mainDropColumn");
      for (let i = 0; i < mainDropColumn.length; i++) {
        mainDropColumn[i].style = "";
      }
    }
    return;
  };

  const cleearFilterFromStorage = (key = null, filters = null) => {
    const groupBy = getGroupForKanban(params.attribute_set_key) || "priority"
    const storagedata = localStorage.getItem("filter");
    let newobj = {};
    if (storagedata && commonData.IsJsonString(storagedata)) {
      const parseData = JSON.parse(storagedata);
      newobj = {
        ...newobj,
        ...parseData,
      };

      if (key === "clear") {
        const selectFilter = localStorage.getItem("selected_filter");

        if (newobj.hasOwnProperty(params.attribute_set_key)) {
          newobj = {
            ...newobj,
            [params.attribute_set_key]: "",
          };
        }

        //select filter

        
        //check the default value from system filter;
        let convertselectfilter = "";
        if (selectFilter && commonData.IsJsonString(selectFilter)) {
          convertselectfilter = JSON.parse(selectFilter);
        }

        const { system_filter } = state.filterView;
        const defaultFilter = system_filter.find(
          (item) => item.is_default === 1
        );
        
        if (defaultFilter && Object.keys(defaultFilter).length) {
          const defaultFiltervalue = defaultFilter?.filter_value;
          if (
            defaultFiltervalue &&
            commonData.IsJsonString(defaultFiltervalue)
          ) {
            filters = JSON.parse(defaultFiltervalue);
            
            newobj = {
              ...newobj,
              [params.attribute_set_key]: JSON.stringify({ ...filters }),
            };
            setState((state) => {
              return {
                ...state,
                filters: {},
              };
            });
          }

          if (convertselectfilter && Object.keys(convertselectfilter).length) {
            convertselectfilter = {
              ...convertselectfilter,
              [params.attribute_set_key]: defaultFilter.filter_id,
            };

            localStorage.setItem(
              "selected_filter",
              JSON.stringify(convertselectfilter)
            );
          }
        }
      } else {
        newobj = {
          ...newobj,
          [params.attribute_set_key]: JSON.stringify({ ...filters }),
        };
      }
      // callTheApiDefaut(filters);
//store the group by
      let groups = {


      }
      let kanbangroupbys = localStorage.getItem("kanbangroupby");
      if(kanbangroupbys && commonData.IsJsonString(kanbangroupbys)) {

        const kanbangroups = JSON.parse(kanbangroupbys);
        groups = {
          ...kanbangroups,
          [params.attribute_set_key]: groupBy || {}
        }
      }else {
        groups = {
          [params.attribute_set_key]: groupBy || {}
        }
      }
      
      
      setGroupByForkanban("priority", params.attribute_set_key)
      localStorage.setItem("filter", JSON.stringify(newobj));
    }
    return;
  };

  const callTheDefaultView = () => {
    // check the system filter is exist inside the filterview or not

    // if it exist then get the default filter value
    if (state.filterView.hasOwnProperty("system_filter")) {
      const systemfilter = state.filterView.system_filter;
      // from the systemfilter get the default value

      const filterValue =
        systemfilter.find((item) => item.is_default === 1)?.filter_value || "";

      // check the filterValue is not blank

      if (filterValue) {
        //filter value we get in string convert to object

        const parsefiltervalue = JSON.parse(filterValue);

        const filters = {
          ...parsefiltervalue,
        };

        //set the value in filter state along with local storage
        setState((state) => {
          return {
            ...state,
            filters,
          };
        });
        cleearFilterFromStorage("set", filters);
      }
    }

    // if it not exist the default filter value
  };


  // save view

  const saveViewFilterHandler = (data) => {
    setState((state) => {
      return {
        ...state,
        newfilters: {
          ...state.filters,
          ...data,
        },
        isFilterCreate: true,
      };
    });
  };

  // close modal to save view
  const closeModal = () => {
    setState((state) => {
      return {
        ...state,
        isFilterCreate: false,
        modalFilterNameError: "",
      };
    });
  };

  // save filter to api
  const createCustomFilterHandler = async (evt) => {
    evt.preventDefault();
    let {group_by,filter_view, ...filtervalues} = state.newfilters
    const filtersData = {
      app_token: commonData.getCommonData().app_token,
      filter_id: Date.now(),
      attribute_set_key: params.attribute_set_key,
      user_uuid: commonData.getCommonData().user_uuid,
      filter_name: customFilterName.current.value,
      filter_value: { ...filtervalues },
      is_system: 0,
    };
    const objKeys = Object.keys(filtersData.filter_value);
    if (validateFilter()) {
      const resp = await fetch(`${state.api}/create-custom-filter`, {
        method: "POST",
        body: JSON.stringify(filtersData),
      });

      const rdata = await resp.json();

      if (rdata.code == 200) {
        let { user_filter } = { ...state.filterView };
        user_filter = [rdata.data, ...user_filter];
        let filtersnw = state.newfilters;
        if (filtersnw ?? {}.hasOwnProperty("columns")) {
          const { columns, ...rest } = filtersnw;
          callTheApiDefaut(rest, null, columns);
        } else {
          callTheApiDefaut(state.newfilters);
        }
        let filterdata = localStorage.getItem("selected_filter");
        if (filterdata) {
          let newfilterdata = JSON.parse(filterdata || "{}");
          let newdatastore = {
            ...newfilterdata,
            [params.attribute_set_key]: rdata.data.filter_id,
          };
          localStorage.setItem(
            "selected_filter",
            JSON.stringify(newdatastore)
          );
        } else {
          let newdatastore = {
            [params.attribute_set_key]: rdata.data.filter_id,
          };
          localStorage.setItem(
            "selected_filter",
            JSON.stringify(newdatastore)
          );
        }

        setState((state) => {
          return {
            ...state,
            filterView: {
              ...state.filterView,
              user_filter: user_filter,
            },
            isFilterCreate: false,
            kanbanName: customFilterName.current.value,
            // createBoard: {
            //   ...state.createBoard,
            //   board: true,
            //   message: rdata.message,
            //   title: rdata.status,
            //   bg: "primary",
            // },
          };
        });
      }
    }
  };

  const showGroupByDropDown = () => {
    setState((state) => {
      return {
        ...state,
        showGroupDropDown: !state.showGroupDropDown,
      };
    });
  };

  const getFilteredObj = (item) => {
    const filterConvert = JSON.parse(item.filter_value ?? "{}");
    let filterdata = localStorage.getItem("selected_filter");
    let newfilterdata = commonData.IsJsonString(filterdata)
      ? JSON.parse(filterdata)
      : "";
    if (newfilterdata) {
      let newdatastore = {
        ...newfilterdata,
        [params.attribute_set_key]: item.filter_id,
      };

      localStorage.setItem(
        "selected_filter",
        JSON.stringify(newdatastore)
      );
      let { filter_view, columns, ...newval } = filterConvert;
      setToLocalStorage(newval);
      if (columns && columns.length > 0) {
        setState((state) => {
          return {
            ...state,
            filters: {
              ...newval,
              columns: columns,
            },
            kanbanName: item.filter_name || customFilterName.current.value,
          };
        });
      } else {
        setState((state) => {
          return {
            ...state,
            filters: {
              ...newval,
            },
            kanbanName: item.filter_name || customFilterName.current.value,
          };
        });
      }

      callTheApiDefaut({ ...newval, filter_id: item.filter_id }, null, columns);
    } else {
      const filterConvert = JSON.parse(item.filter_value ?? "{}");
      let { filter_view, ...newval } = filterConvert;
      setToLocalStorage(filterConvert);
      setState((state) => {
        return {
          ...state,
          filters: {
            ...newval,
          },
          kanbanName: item.filter_name || customFilterName.current.value,
        };
      });
      let newdatastore = {
        [params.attribute_set_key]: item.filter_id,
      };
      localStorage.setItem(
        "selected_filter",
        JSON.stringify(newdatastore)
      );

      callTheApiDefaut({ ...newval, filter_id: item.filter_id });
    }
  };

  const createFilterByView = async (args) => {
    const { user_filter } = state.filterView;
    let getNamefilter = user_filter.find(
      (item) => item.filter_id == state.editFilterId
    );
    let newupdatedata = user_filter.map((it) =>
      it.filter_id == state.editFilterId
        ? { ...it, filter_value: JSON.stringify({ ...args }) }
        : it
    );

    let newvalues = {
      filter_id: state.editFilterId,
      filter_name: getNamefilter.filter_name,
      filter_value: { ...args },
      is_default: 0,
      is_system: 0,
    };

    setState((state) => {
      return {
        ...state,
        filterView: {
          ...state.filterView,
          user_filter: newupdatedata,
        },
        filters: {
          ...state,
          ...args,
        },
      };
    });
    callTheApiDefaut(args);
    const resp = await fetch(`${state.api}/update-custom-filter`, {
      method: "POST",
      body: JSON.stringify(newvalues),
    });

    const rdata = await resp.json();
    if (rdata.code == 200) {
      setState((state) => {
        return {
          ...state,
          enableCustomView: false,
        };
      });
    }
  };
  const getformatdata = (request) => {
    for (let kee in request["filters"]) {
      if (kee == "completed" && request["filters"]["completed"] == "all") {
        request["filters"] = {
          ...delete request["filters"]["completed"],
          ...request["filters"],
        };
      }
      if (
        Array.isArray(request["filters"][kee]) &&
        request["filters"][kee].length === 0
      ) {
        request["filters"] = {
          ...delete request["filters"][kee],
          ...request["filters"],
        };
      }
    }
    return request;
  };
  const getFieldCompletedValue = (nval) => {
    const groupBy = getGroupForKanban(params.attribute_set_key) || "priority"
    const { assign_to, columns, group_by, ...rest } = state.filters || {};
    const filters = {
      ...rest,
      assign_to: assign_to,
      completed: nval,
    };
    setState((state) => {
      return {
        ...state,
        completed: nval,
      };
    });

    resetFilterKanaban();
    setToLocalStorage({ ...filters, groupBy });
    callTheApiDefaut({ ...filters, groupBy }, null, columns);
  };

  // storing filters and data to local storage
  const setToLocalStorage = (filter) => {
    
    let kanban = {};
    let selectfilter = {};
    const getkanbanitem = localStorage.getItem("filter");
    const parseData = commonData.IsJsonString(getkanbanitem)
      ? JSON.parse(getkanbanitem)
      : "";

    if (parseData && parseData[params.attribute_set_key]) {
      let olddata = commonData.IsJsonString(parseData[params.attribute_set_key])
        ? JSON.parse(parseData[params.attribute_set_key])
        : parseData[params.attribute_set_key];

      if (olddata) {
        let {group_by,...rest} = filter
        let newdata = JSON.stringify({ ...rest })
        kanban = {
          ...parseData,
          [params.attribute_set_key]: newdata,
        };
      }

      localStorage.setItem("filter", JSON.stringify(kanban));
    } else {
      let selectfil = localStorage.getItem("selected_filter");

      kanban = {
        ...parseData,
        [params.attribute_set_key]: filter,
      };
      kanban[params.attribute_set_key] = JSON.stringify(filter);
      if (kanban) {
        localStorage.setItem("filter", JSON.stringify(kanban));
      }

      if (selectfil) {
        const parseFil = commonData.IsJsonString(selectfil)
          ? JSON.parse(selectfil)
          : "";

        if (parseFil && filter?.filter_id) {
          selectfilter = {
            ...parseFil,
            [params.attribute_set_key]: filter.filter_id,
          };

          localStorage.setItem(
            "selected_filter",
            JSON.stringify(selectfilter)
          );
        }
      }
    }
  };

  const resetFilterKanaban = () => {
    let selectkanbanfilter = localStorage.getItem("selected_filter");

    if (selectkanbanfilter) {
      let parfil = JSON.parse(selectkanbanfilter);

      parfil = {
        ...delete parfil[params.attribute_set_key],
        ...parfil,
      };

      localStorage.setItem("selected_filter", JSON.stringify(parfil));
    }
  };
  const showFilterSection = () => {
    setState((state) => {
      return {
        ...state,
        showFilterSection: !state.showFilterSection,
      };
    });
  };
  const submitFilterHandler = (val) => {
    let filtersnew = {};
    if (val.hasOwnProperty("columns")) {
      const { columns, ...resting } = val;
      setState((state) => {
        return {
          ...state,
          filters: {
            // ...state.filters,
            ...resting,
          },
          showColumnsArray: columns,
        };
      });
    } else {
      setState((state) => {
        return {
          ...state,
          filters: {
            // ...state.filters,
            ...val,
          },
        };
      });
    }
    const { filter_id, columns, ...rest } = val;

    resetFilterKanaban();
    setToLocalStorage({ ...rest, columns });
    callTheApiDefaut({ ...rest, filter_view: 1 }, null, columns);
  };

  const getHeaderName = (boardName) => {
    if (checkViewType()) return commonData.firstUpper(checkViewType());
    if (boardName && boardName.includes("-")) {
      let newname = boardName
        .split("-")
        .map((it) => it.charAt(0).toUpperCase() + it.slice(1));
      return newname.join(" ");
    }
    return boardName;
  };

  //validate name for view
  const validateFilter = () => {
    if (customFilterName.current.value.trim() === "") {
      setState((state) => {
        return {
          ...state,
          modalFilterNameError: "Please enter the filter name",
        };
      });
      return false;
    } else if (customFilterName.current.value.length > 100) {
      setState((state) => {
        return {
          ...state,
          modalFilterNameError: "Maximum letter length for a name is 100.",
        };
      });
      return false;
    } else {
      setState((state) => {
        return {
          ...state,
          modalFilterNameError: "",
        };
      });

      return true;
    }
  };

  const checkFilterLocalAndConvert = () => {
    const filtervalue = localStorage.getItem("kanban");
    if (filtervalue) {
      // convert from string to object
      let convertfromstring = commonData.IsJsonString(filtervalue)
        ? JSON.parse(filtervalue)
        : "";
      if (convertfromstring) {
        return convertfromstring[params.attribute_set_key];
      }
    }
    if (checkViewType() === "backlog") {
      const filtervalue = localStorage.getItem("advance_filter");
      if (filtervalue) {
        // convert from string to object
        let convertfromstring = commonData.IsJsonString(filtervalue)
          ? JSON.parse(filtervalue)
          : "";
        if (convertfromstring) {
          return convertfromstring[params.attribute_set_key];
        }
      }
    }
  };

  const buildQueryString = (obj, prefix = "") => {
    if (typeof obj === "object" && obj.hasOwnProperty("q")) {
      const queryString = Object.keys(obj?.q)
        .map((key) => {
          const value = obj?.q[key];
          if (typeof value === "object") {
            return buildQueryString(value, `${prefix}${key}.`);
          } else {
            const encodedKey = encodeURIComponent(prefix + key);
            const encodedValue = encodeURIComponent(value);
            return `${encodedKey}=${encodedValue}`;
          }
        })
        .join("&");
      return queryString;
    }
  };

  // copy filter link handler
  const copyFilterLinkHandler = () => {
    setState((state) => {
      return {
        ...state,
        linkCopied: true,
      };
    });
    let filterval = checkFilterLocalAndConvert();
    let newval = { ...filterval, ...state.filters };
    filterval = newval;
    if (filterval) {
      let queryParams = {};
      if (checkViewType() === "backlog") {
        const values = new URLSearchParams(window.location.search).get("q");
        if (values) {
          const parsevalue = JSON.parse(values);
        }
        queryParams = {
          q: values + "&" + filterval,
        };
      } else {
        queryParams = {
          q: { ...filterval, columns: state.filters.columns },
        };
      }
      const queryString = Object.keys(queryParams)
        .map((key) => {
          return `${encodeURIComponent(key)}=${encodeURIComponent(
            typeof queryParams[key] === "string"
              ? queryParams[key]
              : JSON.stringify(queryParams[key])
          )}`;
        })
        .join("&");

      let url = "";
      if (checkViewType() === "backlog") {
        url = `${window.location.origin}${window.location.pathname}?type=backlog&${queryString}`;
      } else {
        url = `${window.location.origin}${window.location.pathname}?${queryString}`;
      }

      navigator.clipboard.writeText(url);
    } else {
      const url = `${window.location.origin}${window.location.pathname}?q=`;
      navigator.clipboard.writeText(url);
    }
    setTimeout(() => {
      setState((state) => {
        return {
          ...state,
          linkCopied: false,
        };
      });
    }, 500);
  };

  const closeRemoveModal = () => {
    setState((state) => {
      return {
        ...state,
        isFilterRemove: false,
      };
    });
  };

  const isValidJson = (str) => {
    try {
      if (JSON.parse(str)) {
        return true;
      }
    } catch (err) {
      return false;
    }
  };

  const removeFilterConfirmHandler = async () => {
    const response = await fetch(`${state.api}delete-custom-filter`, {
      method: "POST",
      body: JSON.stringify({ filter_id: state.removeFilterId }),
    });

    const responseData = await response.json();
    if (responseData.code === 200) {
      const { user_filter } = state.filterView;
      let newfilter = user_filter.filter(
        (item) => item.filter_id != state.removeFilterId
      );
      setState((state) => {
        return {
          ...state,
          filterView: {
            ...state.filterView,
            user_filter: newfilter,
          },
          isFilterRemove: false,
          filterpopup: false,
        };
      });
    }
  };

  // useEffect for to ban the drag and drop condition

  useEffect(() => {
    const groupBy = getGroupForKanban(params.attribute_set_key) || "priority"
    if (state.boarddata.hasOwnProperty("filter")) {
      let kanbanFilter_selected = localStorage.getItem(
        "selected_filter"
      );
      const newidconvert = JSON.parse(kanbanFilter_selected);
      const filter = state.boarddata.filter;
      if (
        (filter &&
          filter.hasOwnProperty("system_filter") &&
          filter.system_filter.length > 0) ||
        (filter &&
          filter.hasOwnProperty("user_filter") &&
          filter.user_filter.length > 0)
      ) {
        let merged_arr = filter.system_filter;
        if (
          filter &&
          filter.hasOwnProperty("user_filter") &&
          filter.user_filter.length > 0
        ) {
          merged_arr = filter.system_filter.concat(filter.user_filter);
        }
        let filtervalue =
          merged_arr ??
          [].find(
            (item) => item.filter_id == newidconvert[params.attribute_set_key]
          );
        if (filtervalue !== undefined) {
          let filterId;
          if (
            kanbanFilter_selected &&
            commonData.IsJsonString(kanbanFilter_selected)
          ) {
            const parsedata = JSON.parse(kanbanFilter_selected)[
              params.attribute_set_key
            ];
            filterId = parsedata;
          }
          setState((state) => {
            return {
              ...state,
              kanbanName:
                (filterId &&
                  filtervalue.find((ite) => ite.filter_id === filterId)
                    ?.filter_name) ||
                customFilterName?.current?.value ||
                state.boarddata.attribute_set_name,
            };
          });
        }
      }
    }
    if (
      (groupBy !== "assign_to" &&
        state.filters?.assign_to?.length > 1) ||
      state.filters?.assign_to?.length === 0
    ) {
      setState((state) => {
        return {
          ...state,
          isSetNotAllowed: true,
        };
      });
    } else {
      setState((state) => {
        return {
          ...state,
          isSetNotAllowed: false,
        };
      });
    }
  }, [state.filters]);

  // function for return draggable card item

  const renderDragableCardItem = (
    provided,
    snapshot,
    item,
    column,
    pinnedData
  ) => {
    return (provided, snapshot) => {
      return createLayoutDropabble(
        provided,
        snapshot,
        item,
        column,
        pinnedData
      );
    };
  };

  const getAttributeWithGroupBy = () => {
        const groupBy = getGroupForKanban(params.attribute_set_key) || "priority"
        
        if ((state.filters.group_by || groupBy) === "assign_to") {
          
      if (state.newOptionColumns.length) {
        return state.newOptionColumns;
      }
      return (
        state.users &&
        Object.keys(state.users).map((it, index) => ({
          name: state.users[it]?.name,
          user_uuid: state.users[it]?.user_uuid,
        }))
      );
    }
    const attr =
      state.columns.find(
        (item) => item.attribute_type === groupBy
      ) ?? {};
    if (attr.hasOwnProperty("options")) {
      const { options } = attr;
      if (state.newOptionColumns.length) {
        return state.newOptionColumns;
      }
      return options ?? [];
    }
    return [];
  };

  const populateField = (evt) => {
        const groupBy = getGroupForKanban(params.attribute_set_key) || "priority"
        
    let newoptcheck = [];
    if (evt) {
      const { value } = evt.target;

      let filteredOptions;

      if ((state.filters.group_by || groupBy) === "assign_to") {
        
        filteredOptions =
          state.users &&
          Object.keys(state.users)
            .map((it, index) => ({
              user_uuid: state.users[it]?.user_uuid,
              name: state.users[it]?.name,
            }))
            .filter((itt) =>
              itt.name?.toLowerCase().includes(value.toLowerCase())
            );
      } else {
        // Retrieve the original options to filter independently
        const options =
          state.columns.find(
            (item) => item.attribute_type === state.filters.group_by || groupBy
          )?.options ?? [];

        // Filter the options based on the input value
        filteredOptions = options.filter((it) => {
          if (it.name) {
            return it.name.toLowerCase().includes(value.toLowerCase());
          } else {
            return it.option_name.toLowerCase().includes(value.toLowerCase());
          }
        });
        // console.log(newoptions, newoptionsnew, value, 67534523423423);
      }

      setState((state) => {
        return {
          ...state,
          newOptionColumns: filteredOptions,
        };
      });

      return;
    }
    if (groupBy === "assign_to") {
      
      const options = getAttributeWithGroupBy();
      newoptcheck = options.map((it, index) => {
        return { label: it.name, value: it.user_uuid };
      });
    } else {
      const options = getAttributeWithGroupBy();

      newoptcheck = options.map((check, index) => {
        return { label: check.name || check.option_name, value: check._id };
      });
    }
    return (
      isMounted && (
        <div className="new-check-renderer">
          <CheckPicker
            defaultOpen={true}
            data={newoptcheck}
            onChange={inputChangeCheckboxHandler}
            searchable
            // block={true}
            inputRef={refgroupcategoryMain}
            defaultValue={state.showColumnsArray || []}
            renderMenu={menuRender}
            preventOverflow={true}
            onOpen={() => setIsMounted(true)}
            menuClassName={isMounted ? "show" : "hidden"}
          />
        </div>
      )
    );
  };

  // layout design

  const createLayoutDropabble = (
    provided,
    snapshot,
    item,
    column,
    pinnedData
  ) => {
    const groupBy = getGroupForKanban(params.attribute_set_key) || "priority"
    return (
      <div
        ref={provided.innerRef}
        {...provided.draggableProps}
        {...provided.dragHandleProps}
        id={`draggable`}
        style={{
          userSelect: "none",

          margin: "0 0 8px",
          minHeight: "50px",
          backgroundColor: snapshot.isDragging ? "rgb(249 249 249)" : "#fff",
          color: "#000",
          borderRadius: "5px",
          whiteSpace: "break-spaces",
          wordBreak: "break-all",
          boxShadow:
            "var(--ds-shadow-raised, 0px 1px 1px #091e423f, 0px 0px 1px #091e4221)",
          ...provided.draggableProps.style,
          cursor: state.isSetNotAllowed
            ? "not-allowed"
            : column.length > 100
            ? "not-allowed"
            : "auto",
        }}
        onClick={() =>
          state.boarddata.attribute_set_type === 4
            ? onDragEditHandler(
                item[groupBy],
                item.customer_tattle_uuid,
                pinnedData
              )
            : null
        }
      >
        <div className="main_section">
          {getFormFieldWithValue(state.columns, item, pinnedData)}
        </div>
      </div>
    );
  };

  let usersAll = Object.keys(state.users).map((item) => ({
    label: state.users[item].name,
    value: state.users[item].user_uuid,
    profile_image: state.users[item].profile_image,
  }));

  const groupBy = getGroupForKanban(params.attribute_set_key) || "priority"

  return (
    <>
      <Error>
        <Message board={state.createBoard} position="bottom-end" />
        {assigntorelease ? (
          <BModal show={assigntorelease} centered onHide={assigntoRelease}>
            <BModal.Header closeButton>
              <BModal.Title>Assign to Release</BModal.Title>
            </BModal.Header>
            <BModal.Body>
              <div className="assign_to_release_form">
                <AsyncSelect
                  cacheOptions
                  defaultOptions
                  loadOptions={callApiHandler}
                  onChange={assigntoReleasechange}
                />
                <button
                  className="muBtn _blue"
                  onClick={submitAssigntoReleaseHandler}
                >
                  Save
                </button>
              </div>
            </BModal.Body>
          </BModal>
        ) : (
          ""
        )}
        <Modal
          show={state.isFilterRemove}
          className="confirm"
          close={closeRemoveModal}
        >
          <div className="deleteAlert">
            <p>Do you want to delete this filter?</p>
            <div className="actionDelete">
              <Button
                className="muBtn _blue"
                text="Yes"
                onClick={() => removeFilterConfirmHandler()}
              />{" "}
              &nbsp;
              <Button
                className="muBtn _grey"
                text="Cancel"
                onClick={closeRemoveModal}
              />
            </div>
          </div>
        </Modal>
        {state.isFilterCreate && (
          <Modal show={state.isFilterCreate} close={closeModal}>
            <Form onSubmit={createCustomFilterHandler}>
              <div className="row">
                <div className="form-group">
                  <label>
                    View Name <span className="required_filter">*</span>
                  </label>{" "}
                  <input
                    type={"text"}
                    className="form-control"
                    placeholder="Custom view name"
                    name="filter_name"
                    ref={customFilterName}
                    onChange={validateFilter}
                    autoComplete="off"
                  />
                </div>
                <span className="required_filter">
                  {state.modalFilterNameError}
                </span>
              </div>
              <div className="row">
                <div className="form-group">
                  <Button
                    text="Create View"
                    type="submit"
                    className="muBtn _blue mb-3 mt-3"
                  />
                </div>
              </div>
            </Form>
          </Modal>
        )}
        {state.showTodoNote && (
          <MainCanvas
            show={state.showTodoNote}
            onClose={canvasCloseHandler}
            title="Notes"
          >
            {getNoteTodoView()}
          </MainCanvas>
        )}
        <ErCanvas
          show={state.showAddCanvas}
          onClose={closeAddCanvas}
          name={`Add ${getHeaderName(state?.boarddata?.attribute_set_name)}`}
        >
          {/* update and edit todo */}
          <TodoHandler
            columnsDefs={state?.columns || []}
            show={state.showAddCanvas}
            loading={state.loading}
            user_uuid={state.user_uuid}
            defaultCheck={defaultCheck}
            newformData={state.formdata}
            activeUsers={state.activeUsers}
            findUUID={state.findUUID}
            group_by={groupBy}
            getHiddenFormFieldValue={getHiddenFormFieldValue}
            showAllattribute={state.showAllattribute}
            showHideAttribute={showHideAttribute}
            isSubmitting={state.isSubmitting}
            formSubmitHandler={formSubmitHandler}
          />
        </ErCanvas>
        {state.editShowCanvas && Object.keys(state.formdata).length > 0 && (
          <ErCanvas
            show={state.editShowCanvas}
            onClose={closeEditCanvas}
            name={`Edit ${getHeaderName(state?.boarddata?.attribute_set_name)}`}
          >
            {/* adding todo canvas */}
            <TodoHandler
              columnsDefs={state.columns}
              loading={state.loading}
              newformData={state.formdata}
              getHiddenFormFieldValue={getHiddenFormFieldValue}
              showAllattribute={state.showAllattribute}
              showHideAttribute={showHideAttribute}
              isSubmitting={state.isSubmitting}
              formSubmitHandler={formSubmitHandler}
            />
          </ErCanvas>
        )}
        <div className="mainContent-panel-wrap kanban">
          <Header
            brecum_name={{
              name: "Kanban",
              link: `/tattle/${state.boarddata.attribute_set_key}/kanban`,
            }}
            brecum_page={state.boarddata.attribute_set_name}
            pageName={state.boarddata.attribute_set_name}
          />

          {state.enableCustomView && (
            <NewCustomFilter
              values={state.editFilterValues || ""}
              show={state.enableCustomView}
              onClose={closeCustomFilter}
              title="Create View"
              isEdit={state.isEdit}
              isFilterCreate={saveViewFilterHandler}
              filterSubmit={submitFilterHandler}
              // isKanban={true}
              createFilterByView={createFilterByView}
              type={state.boarddata.attribute_set_type}
            />
          )}

          <div className="main_custom_class">
            <CustomFilter
              filters={state.filterView}
              getFilteredObj={getFilteredObj}
              enebleClickFilter={enebleClickFilter}
              isEdit={state.isEdit}
              values={state.editFilterValues || ""}
              removeFilterHandler={removeFilterHandler}
              isKanban={true}
              attribute_set_type={state.boarddata.attribute_set_type}
            />
            <div
              className="page-content pt-0 new-content-main"
              style={!togglemenu ? { marginLeft: "181px" } : {}}
            >
              <div className="new-content-main">
                <Container fluid className="p-0">
                  <Card className="filterCardClass">
                    <Card.Body className="p-2 ps-3">
                      <div className="filterGroup">
                        <div className="main_header_top">
                          <div className="manage-columns-header-name">
                            <OverlayTrigger
                              key={"kanban-check"}
                              placement={"top"}
                              overlay={
                                <Tooltip id={`kanban-group-check`}>
                                  <strong>
                                  {checkViewType() ? checkViewType() : state.kanbanName
                                      ? state.kanbanName
                                      : getHeaderName(
                                          state?.boarddata?.attribute_set_name
                                        )}
                                  </strong>
                                </Tooltip>
                              }
                            >
                              <h5 className="inline-edit-board">
                              {checkViewType() ? checkViewType().charAt(0).toUpperCase() + checkViewType().slice(1) : state.kanbanName &&
                                    state.kanbanName.length > 20
                                  ? state.kanbanName.slice(0, 20) + "..."
                                  : state.kanbanName
                                  ? state.kanbanName
                                  : getHeaderName(
                                      state?.boarddata?.attribute_set_name
                                    )} ({state.total_count})
                              </h5>
                            </OverlayTrigger>
                          </div>

                          <div className="top_header_Custom kanban_custom_group">
                            <div className="customviewc">
                              <Button
                                className="muBtn kanbanCopyLink"
                                onClick={copyFilterLinkHandler}
                                color={"#7b8794"}
                                fSize={16}
                                padding={"9px 10px"}
                              >
                                <OverlayTrigger
                                  key={"kanban-check"}
                                  placement={"top"}
                                  overlay={
                                    <Tooltip id={`kanban-group-check`}>
                                      <strong>Copy Link</strong>
                                    </Tooltip>
                                  }
                                >
                                  <i className="fa fa-copy"></i>
                                </OverlayTrigger>{" "}
                              </Button>

                              <span
                                className={`copy_link ${
                                  state.linkCopied ? "enablecopilinked" : ""
                                }`}
                              >
                                Link Copied
                              </span>
                            </div>
                            <div className="manage-columns-section">
                              <OverlayTrigger
                                key={"kanban"}
                                placement={"top"}
                                overlay={
                                  <Tooltip id={`manage-columns`}>
                                    <strong>Manage Columns</strong>
                                  </Tooltip>
                                }
                              >
                                <div
                                  class="dropdown"
                                  onClick={showGroupDropDown}
                                >
                                  <div
                                    // class="dropdown-toggle "
                                    id="dropdownMenuReference"
                                    data-bs-toggle="dropdown"
                                    aria-haspopup="true"
                                    aria-expanded="false"
                                    data-bs-reference="parent"
                                  >
                                    <span class="span-svg">
                                      <svg
                                        width="15"
                                        height="15"
                                        viewBox="0 0 14 14"
                                        fill="none"
                                        xmlns="http://www.w3.org/2000/svg"
                                      >
                                        <g clip-path="url(#clip0_1249_27754)">
                                          <path
                                            d="M10.4649 10.465C9.46776 11.2251 8.25357 11.6462 6.99992 11.6667C2.91659 11.6667 0.583252 6.99999 0.583252 6.99999C1.30885 5.64777 2.31525 4.46635 3.53492 3.53499M5.77492 2.47333C6.17645 2.37934 6.58754 2.33236 6.99992 2.33333C11.0833 2.33333 13.4166 6.99999 13.4166 6.99999C13.0625 7.66243 12.6402 8.28609 12.1566 8.86083M8.23659 8.23666C8.07637 8.4086 7.88317 8.5465 7.66851 8.64215C7.45384 8.7378 7.22211 8.78923 6.98714 8.79337C6.75217 8.79752 6.51876 8.7543 6.30086 8.66628C6.08295 8.57826 5.88501 8.44726 5.71883 8.28108C5.55265 8.11491 5.42165 7.91696 5.33363 7.69905C5.24562 7.48115 5.20239 7.24775 5.20654 7.01277C5.21068 6.7778 5.26212 6.54607 5.35776 6.33141C5.45341 6.11674 5.59132 5.92354 5.76325 5.76333"
                                            stroke="#202223"
                                            stroke-opacity="0.5"
                                            stroke-width="1.33"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          ></path>
                                          <path
                                            d="M0.583252 0.583344L13.4166 13.4167"
                                            stroke="#202223"
                                            stroke-opacity="0.5"
                                            stroke-width="1.33"
                                            stroke-linecap="round"
                                            stroke-linejoin="round"
                                          ></path>
                                        </g>
                                        <defs>
                                          <clipPath id="clip0_1249_27754">
                                            <rect
                                              width="14"
                                              height="14"
                                              fill="white"
                                            ></rect>
                                          </clipPath>
                                        </defs>
                                      </svg>
                                    </span>
                                  </div>
                                  {state.showDropDownGroup && isMounted && (
                                    <div
                                      class="dropdown-menu-start newfieldtogg"
                                      style={{
                                        minWidth: "184px",
                                        border: "none",
                                      }}
                                    >
                                      <div
                                        className="main_field_scroll"
                                        ref={refgroupcategory}
                                      >
                                        {populateField()}
                                        {/* <div className="searchDropDown px-2">
                                          <input
                                            type="text"
                                            className="searchhiddenfield form-control"
                                            onChange={populateField}
                                            placeholder="Search..."
                                          />
                                          <label
                                            htmlFor=""
                                            className="grouplabel"
                                          >
                                            <input
                                              type="checkbox"
                                              name=""
                                              id=""
                                              className="form-check-input"
                                              checked={checkSelectAllHandler()}
                                              onClick={selectAllCheckHandler}
                                            />{" "}
                                            Select All
                                          </label>
                                        </div> */}
                                      </div>
                                      {/* <div className="apply_button_field_group">
                                    <button
                                      className="muBtn _blue"
                                      onClick={hideColumnGroupApiCall}
                                    >
                                      Apply
                                    </button>
                                  </div> */}
                                    </div>
                                  )}
                                </div>
                              </OverlayTrigger>
                            </div>
                            <div className="col" style={{ marginRight: 10 }}>
                              <Search
                                placeholder="Search By Title or ID or Description"
                                width={450}
                                onChange={searchGrid}
                                val={state.globalSearch}
                              />
                            </div>

                            <div onClick={resetAllFilter}>
                              <TimeSvg />
                            </div>
                            {/* <AssignTo
                              users={state.users}
                              filter={state.assignUsers}
                              assignToChangeHandler={assignToChangeHandler}
                              groupBy={state.filters.group_by}
                              headerName={"Assign To"}
                            /> */}
                            {/* {checkViewType() === "backlog" && (
                              <div className="add_backlog_er">
                                <AutoCompleteRelateER
                                  getReletedTattleId={getReletedTattleIdHandler}
                                  clearautocomplete={state.clearautocomplete}
                                  clearTattleIdHandler={clearTattleIdHandler}
                                />
                                <button
                                  className="muBtn _blue"
                                  onClick={submitBacklogHandler}
                                >
                                  <span class="svg" style={{ width: "17px" }}>
                                    <PlusSvg />
                                  </span>{" "}
                                  Add to Backlog
                                </button>
                              </div>
                            )} */}

                            {state.boarddata.attribute_set_type != 4 && (
                              <Link
                                to={{
                                  pathname: `/tattle/${params.attribute_set_key}/add`,
                                }}
                                className="muBtn _blue"
                              >
                                <span class="svg" style={{ width: "17px" }}>
                                  <PlusSvg />
                                </span>{" "}
                                Add {state.boarddata.attribute_set_name}
                              </Link>
                            )}

                            <FilterIcon
                              onClick={showFilterSection}
                              show={state.showFilterSection}
                              params={state.boarddata.attribute_set_type}
                            />

                            {getKanbanViewUi()}
                            {/* <span
                            onClick={showIsKanban}
                            className="kanban-dropdown"
                          >
                            {getKanbanViewUi()}
                          </span>
                          {state.isShowKanban && (
                            <ul
                              className={`dropdown-menu dropdown-menu-start hide-area viewkanban ${
                                state.isShowKanban ? "show" : ""
                              }`}
                              ref={kanbanref}
                            >
                              {getKanbanLi()}
                            </ul>
                          )} */}
                          </div>
                        </div>
                        {/* <div className="grouptwo">
                      <div className="filterDrop">
                        {getFilterViewSelect()}

                        <Button
                          className="muBtn _blue kanbanbtn"
                          onClick={saveViewFilterHandler}
                        >
                          Save View
                        </Button>
                      </div>
                    </div> */}
                      </div>
                    </Card.Body>
                  </Card>
                </Container>
              </div>

              {state.showFilterSection && (
                <div className="py-2 filterdiv_parent isKanenable col-md-12">
                  <div className="main-two-section">
                    <div className="row justify-content-start allFilterFileds">
                      {state.columns
                        .filter(
                          (sk) =>
                            sk.show_in_kanban &&
                            sk.attribute_type !== "assign_to"
                        )
                        .map((item, index, array) => {
                          if (index === 0) {
                            return (
                              <>
                                <div className="header-filter-class">
                                  <label>Group</label>
                                  <ReactSelect
                                    classNamePrefix={"group-kanban"}
                                    styles={customStylesNew}
                                    options={state.columns
                                      .filter((item) => item.show_group_by)
                                      .map((it) => ({
                                        label: it.headerName,
                                        value: it.field,
                                      }))}
                                    value={state.columns
                                      .filter((item) => item.show_group_by)
                                      .map((it) => ({
                                        label: it.headerName,
                                        value: it.field,
                                      }))
                                      .filter(
                                        (ii) =>
                                          ii.value == (getGroupForKanban(params.attribute_set_key) || "priority")
                                      )}
                                    onChange={groupChangeHandler}
                                  />
                                </div>
                                <HeaderShowKanban
                                  item={item}
                                  users={state.users}
                                  filters={state.filters}
                                  param={state.attribute_set_key}
                                  assignToChangeHandler={assignToChangeHandler}
                                  groupBy={groupBy}
                                  completed={state.filters}
                                  getFieldCompletedValue={
                                    getFieldCompletedValue
                                  }
                                  dynamicFilterChangeHandler={
                                    dynamicFilterChangeHandler
                                  }
                                  clearFormDataFilter={clearFormDataFilter}
                                  advance_filter={state.filters.advance_filter}
                                />
                              </>
                            );
                          }

                          return (
                            <>
                              <HeaderShowKanban
                                item={item}
                                users={state.users}
                                filters={state.filters}
                                param={state.attribute_set_key}
                                assignToChangeHandler={assignToChangeHandler}
                                groupBy={groupBy}
                                completed={state.filters}
                                getFieldCompletedValue={getFieldCompletedValue}
                                dynamicFilterChangeHandler={
                                  dynamicFilterChangeHandler
                                }
                                clearFormDataFilter={clearFormDataFilter}
                                advance_filter={state.filters.advance_filter}
                              />
                            </>
                          );
                        })}
                    </div>

                    {/* <div className="col-md-1 onegroupkanban">
                      <label htmlFor="">Group By</label>
                      <div>
                        <input
                          type="text"
                          name=""
                          id=""
                          value={
                            state?.filters?.group_by?.includes("_")
                              ? state?.filters?.group_by
                                  .split("_")
                                  .map(
                                    (it) =>
                                      it?.charAt(0).toUpperCase() + it.slice(1)
                                  )
                                  .join(" ")
                              : state?.filters?.group_by
                                  ?.charAt(0)
                                  .toUpperCase() +
                                  state?.filters?.group_by?.slice(1) || ""
                          }
                          className="form-control"
                          disabled
                        />
                      </div>
                    </div> */}
                  </div>

                  {/* {groupByFunc()} */}
                </div>
              )}
              {state.assignToReleaseData.length ? (
                <div className="filter-release-backlog">
                  <StatusBar
                    selectedrowsdata={state.assignToReleaseData}
                    userType={1}
                    isBulkUpload={state.isBulkUpload}
                    noHide={[]}
                    columnDef={state.columns || []}
                    showAttributeListDropDown={showAttributeListDropDown}
                    showattrdrop={state.showattrdrop}
                    hideattrdrop={hideattrdrop}
                    submitBulkUpdate={submitBulkUpdate}
                    type="item"
                    users={state.users}
                    className="kabanbulk"
                    viewType="kanbanview"
                    clearBulkAction={clearBulkAction}
                  />
                  {/* <button onClick={assigntoRelease}>Assign to Release</button>
                  <button
                    onClick={removeFromBacklogHandler}
                    disabled={state.isReleaseFromBack}
                  >
                    Remove from Backlog
                  </button> */}
                </div>
              ) : (
                ""
              )}
              <Card className="border-0 main_child_class">
                <div
                  // style={{ overflow: "hidden" }}
                  // style={{ overflow: "hidden" }}
                  className="main_scroll_content kanbancard"
                  id="horizontal-scroll-container"
                  ref={containerRef}
                >
                  {Object.entries(state.cardData)?.length ? (
                    <DragDropContext
                      // onDragStart={(evt) => onDragCardHandler(evt)}
                      onDragEnd={(result) =>
                        state.boarddata.attribute_set_type == 4
                          ? onDragEndToDo(
                              result,
                              state.cardData,
                              setState,
                              state,
                              params,
                              userdetails
                            )
                          : onDragEndOther(
                              result,
                              state.cardData,
                              setState,
                              state,
                              params,
                              userdetails
                            )
                      }
                      // onDragStart={(evt) =>
                      //   handleDragStart(evt, setIsScrolling, setDraggedItemIndex)
                      // }

                      // onBeforeDragStart={onBeforeDragStart}
                    >
                      <Droppable
                        droppableId="all-columns"
                        direction="horizontal"
                        type="column"
                      >
                        {(provided) => {
                          return (
                            <ReactSortable
                              list={Object.entries(state.cardData)}
                              setList={(cols) => getColsResiFunc(cols)}
                              onEnd={({ oldIndex, newIndex }) =>
                                onDragDropEnds(oldIndex, newIndex)
                              }
                              {...provided.draggableProps}
                              ref={provided.innerRef}
                              className="main_kanban_layout"
                            >
                              {state.isCallingApi ? (
                                <>
                                  <div className="loading-skeleton">
                                    <div class="col">
                                      <div>
                                        <div>
                                          <p class="card-text">
                                            Some quick example text to build on
                                            the card title and make up the bulk
                                            of the card's content.
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="loading-skeleton">
                                    <div class="col">
                                      <div>
                                        <div>
                                          <p class="card-text">
                                            Some quick example text to build on
                                            the card title and make up the bulk
                                            of the card's content.
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="loading-skeleton">
                                    <div class="col">
                                      <div>
                                        <div>
                                          <p class="card-text">
                                            Some quick example text to build on
                                            the card title and make up the bulk
                                            of the card's content.
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                  <div className="loading-skeleton">
                                    <div class="col">
                                      <div>
                                        <div>
                                          <p class="card-text">
                                            Some quick example text to build on
                                            the card title and make up the bulk
                                            of the card's content.
                                          </p>
                                        </div>
                                      </div>
                                    </div>
                                  </div>
                                </>
                              ) : (
                                Object.entries(state.cardData).map(
                                  ([id, column], cindex) => {
                                    return getDragUi(column, id, cindex);
                                  }
                                )
                              )}
                            </ReactSortable>
                          );
                        }}
                      </Droppable>
                    </DragDropContext>
                  ) : (
                    !state.isFetching && (
                      <div className="no_record_found_kanban">
                        <div className="child_kanban_noreRecord">
                          <div className="no_record_message">
                            <div className="placeholderimage">
                              <NoRecord />

                              <div class="title_no_record">No Record found</div>
                            </div>
                          </div>
                        </div>
                      </div>
                    )
                  )}
                </div>
              </Card>
            </div>
          </div>
        </div>
      </Error>
    </>
  );
};

const dispatchToProps = (dispatch) => {
  return {
    removeFilter: (input) => {
      dispatch(action.removeFilter(input));
    },
  };
};

export default connect(null, dispatchToProps)(Kanban);
